var cn = Object.defineProperty;
var s = (e, t) => cn(e, "name", { value: t, configurable: !0 });
import { jsx as o, jsxs as T, Fragment as z } from "react/jsx-runtime";
import * as c from "react";
import { createContext as un, useContext as dn, useRef as B, useState as I, useEffect as R, forwardRef as K, useCallback as N, useMemo as G, useLayoutEffect as Je } from "react";
import { clsx as Q } from "clsx";
import { print as Oe, astFromValue as hn, isSchema as ht, buildClientSchema as mn, validateSchema as fn, getIntrospectionQuery as pn, isNamedType as Nt, isObjectType as xe, isInputObjectType as Fe, isScalarType as gn, isEnumType as kt, isInterfaceType as Ee, isUnionType as Cn, isNonNullType as Tt, isListType as Mt, isAbstractType as vn, isType as yn, parse as Vt, visit as bn } from "graphql";
import { StorageAPI as Ye, HistoryStore as wn, formatResult as Xe, isObservable as xn, formatError as ve, isAsyncIterable as En, fetcherReturnToPromise as mt, isPromise as ft, mergeAst as Ln, fillLeafs as Sn, getSelectedOperationName as Nn } from "@graphiql/toolkit";
import { getFragmentDependenciesForAST as kn, GraphQLDocumentMode as Tn, getOperationFacts as Mn } from "graphql-language-service";
import je from "set-value";
import Vn from "copy-to-clipboard";
import * as oe from "@radix-ui/react-dialog";
import { Root as Hn } from "@radix-ui/react-visually-hidden";
import { Trigger as An, Root as qn, Portal as Rn, Content as Dn, Item as Pn } from "@radix-ui/react-dropdown-menu";
import In from "markdown-it";
import { Reorder as Ht } from "framer-motion";
import * as ge from "@radix-ui/react-tooltip";
import { Combobox as he } from "@headlessui/react";
import pt from "react-dom";
function ae(e) {
  const t = un(null);
  return t.displayName = e, t;
}
s(ae, "createNullableContext");
function ce(e) {
  function t(n) {
    var l;
    const r = dn(e);
    if (r === null && (n != null && n.nonNull))
      throw new Error(
        `Tried to use \`${((l = n.caller) == null ? void 0 : l.name) || t.caller.name}\` without the necessary context. Make sure to render the \`${e.displayName}Provider\` component higher up the tree.`
      );
    return r;
  }
  return s(t, "useGivenContext"), Object.defineProperty(t, "name", {
    value: `use${e.displayName}`
  }), t;
}
s(ce, "createContextHook");
const At = ae("StorageContext");
function On(e) {
  const t = B(!0), [n, r] = I(new Ye(e.storage));
  return R(() => {
    t.current ? t.current = !1 : r(new Ye(e.storage));
  }, [e.storage]), /* @__PURE__ */ o(At.Provider, { value: n, children: e.children });
}
s(On, "StorageContextProvider");
const ue = ce(At), Fn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M5.0484 1.40838C6.12624 0.33054 7.87376 0.330541 8.9516 1.40838L12.5916 5.0484C13.6695 6.12624 13.6695 7.87376 12.5916 8.9516L8.9516 12.5916C7.87376 13.6695 6.12624 13.6695 5.0484 12.5916L1.40838 8.9516C0.33054 7.87376 0.330541 6.12624 1.40838 5.0484L5.0484 1.40838Z", stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("rect", { x: 6, y: 6, width: 2, height: 2, rx: 1, fill: "currentColor" })), "SvgArgument"), Bn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 14 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M1 1L7 7L13 1", stroke: "currentColor", strokeWidth: 1.5 })), "SvgChevronDown"), Wn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M6 1.04819L2 5.04819L6 9.04819", stroke: "currentColor", strokeWidth: 1.75 })), "SvgChevronLeft"), _n = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 14 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M13 8L7 2L1 8", stroke: "currentColor", strokeWidth: 1.5 })), "SvgChevronUp"), $n = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 14 14", stroke: "currentColor", strokeWidth: 3, xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M1 1L12.9998 12.9997" }), /* @__PURE__ */ c.createElement("path", { d: "M13 1L1.00079 13.0003" })), "SvgClose"), Zn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "-2 -2 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M11.25 14.2105V15.235C11.25 16.3479 10.3479 17.25 9.23501 17.25H2.76499C1.65214 17.25 0.75 16.3479 0.75 15.235L0.75 8.76499C0.75 7.65214 1.65214 6.75 2.76499 6.75L3.78947 6.75", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ c.createElement("rect", { x: 6.75, y: 0.75, width: 10.5, height: 10.5, rx: 2.2069, stroke: "currentColor", strokeWidth: 1.5 })), "SvgCopy"), Gn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M5.0484 1.40838C6.12624 0.33054 7.87376 0.330541 8.9516 1.40838L12.5916 5.0484C13.6695 6.12624 13.6695 7.87376 12.5916 8.9516L8.9516 12.5916C7.87376 13.6695 6.12624 13.6695 5.0484 12.5916L1.40838 8.9516C0.33054 7.87376 0.330541 6.12624 1.40838 5.0484L5.0484 1.40838Z", stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("path", { d: "M5 9L9 5", stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("path", { d: "M5 5L9 9", stroke: "currentColor", strokeWidth: 1.2 })), "SvgDeprecatedArgument"), Qn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M4 8L8 4", stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("path", { d: "M4 4L8 8", stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 1.2H9C9.99411 1.2 10.8 2.00589 10.8 3V9C10.8 9.99411 9.99411 10.8 9 10.8H8.5V12H9C10.6569 12 12 10.6569 12 9V3C12 1.34315 10.6569 0 9 0H8.5V1.2ZM3.5 1.2V0H3C1.34315 0 0 1.34315 0 3V9C0 10.6569 1.34315 12 3 12H3.5V10.8H3C2.00589 10.8 1.2 9.99411 1.2 9V3C1.2 2.00589 2.00589 1.2 3 1.2H3.5Z", fill: "currentColor" })), "SvgDeprecatedEnumValue"), jn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("rect", { x: 0.6, y: 0.6, width: 10.8, height: 10.8, rx: 3.4, stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("path", { d: "M4 8L8 4", stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("path", { d: "M4 4L8 8", stroke: "currentColor", strokeWidth: 1.2 })), "SvgDeprecatedField"), zn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0.5 12 12", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("rect", { x: 7, y: 5.5, width: 2, height: 2, rx: 1, transform: "rotate(90 7 5.5)", fill: "currentColor" }), /* @__PURE__ */ c.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8 9L10.8 9.5C10.8 10.4941 9.99411 11.3 9 11.3L3 11.3C2.00589 11.3 1.2 10.4941 1.2 9.5L1.2 9L-3.71547e-07 9L-3.93402e-07 9.5C-4.65826e-07 11.1569 1.34314 12.5 3 12.5L9 12.5C10.6569 12.5 12 11.1569 12 9.5L12 9L10.8 9ZM10.8 4L12 4L12 3.5C12 1.84315 10.6569 0.5 9 0.5L3 0.5C1.34315 0.5 -5.87117e-08 1.84315 -1.31135e-07 3.5L-1.5299e-07 4L1.2 4L1.2 3.5C1.2 2.50589 2.00589 1.7 3 1.7L9 1.7C9.99411 1.7 10.8 2.50589 10.8 3.5L10.8 4Z", fill: "currentColor" })), "SvgDirective"), Un = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 20 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M0.75 3C0.75 1.75736 1.75736 0.75 3 0.75H17.25C17.8023 0.75 18.25 1.19772 18.25 1.75V5.25", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ c.createElement("path", { d: "M0.75 3C0.75 4.24264 1.75736 5.25 3 5.25H18.25C18.8023 5.25 19.25 5.69771 19.25 6.25V22.25C19.25 22.8023 18.8023 23.25 18.25 23.25H3C1.75736 23.25 0.75 22.2426 0.75 21V3Z", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ c.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5.25C1.75736 5.25 0.75 4.24264 0.75 3V21C0.75 22.2426 1.75736 23.25 3 23.25H18.25C18.8023 23.25 19.25 22.8023 19.25 22.25V6.25C19.25 5.69771 18.8023 5.25 18.25 5.25H3ZM13 11L6 11V12.5L13 12.5V11Z", fill: "currentColor" })), "SvgDocsFilled"), Kn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 20 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M0.75 3C0.75 4.24264 1.75736 5.25 3 5.25H17.25M0.75 3C0.75 1.75736 1.75736 0.75 3 0.75H16.25C16.8023 0.75 17.25 1.19772 17.25 1.75V5.25M0.75 3V21C0.75 22.2426 1.75736 23.25 3 23.25H18.25C18.8023 23.25 19.25 22.8023 19.25 22.25V6.25C19.25 5.69771 18.8023 5.25 18.25 5.25H17.25", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ c.createElement("line", { x1: 13, y1: 11.75, x2: 6, y2: 11.75, stroke: "currentColor", strokeWidth: 1.5 })), "SvgDocs"), Jn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("rect", { x: 5, y: 5, width: 2, height: 2, rx: 1, fill: "currentColor" }), /* @__PURE__ */ c.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 1.2H9C9.99411 1.2 10.8 2.00589 10.8 3V9C10.8 9.99411 9.99411 10.8 9 10.8H8.5V12H9C10.6569 12 12 10.6569 12 9V3C12 1.34315 10.6569 0 9 0H8.5V1.2ZM3.5 1.2V0H3C1.34315 0 0 1.34315 0 3V9C0 10.6569 1.34315 12 3 12H3.5V10.8H3C2.00589 10.8 1.2 9.99411 1.2 9V3C1.2 2.00589 2.00589 1.2 3 1.2H3.5Z", fill: "currentColor" })), "SvgEnumValue"), Yn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("rect", { x: 0.6, y: 1.1, width: 10.8, height: 10.8, rx: 2.4, stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("rect", { x: 5, y: 5.5, width: 2, height: 2, rx: 1, fill: "currentColor" })), "SvgField"), Xn = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 24 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M1.59375 9.52344L4.87259 12.9944L8.07872 9.41249", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }), /* @__PURE__ */ c.createElement("path", { d: "M13.75 5.25V10.75H18.75", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square" }), /* @__PURE__ */ c.createElement("path", { d: "M4.95427 11.9332C4.55457 10.0629 4.74441 8.11477 5.49765 6.35686C6.25089 4.59894 7.5305 3.11772 9.16034 2.11709C10.7902 1.11647 12.6901 0.645626 14.5986 0.769388C16.5071 0.893151 18.3303 1.60543 19.8172 2.80818C21.3042 4.01093 22.3818 5.64501 22.9017 7.48548C23.4216 9.32595 23.3582 11.2823 22.7203 13.0853C22.0824 14.8883 20.9013 16.4492 19.3396 17.5532C17.778 18.6572 15.9125 19.25 14 19.25", stroke: "currentColor", strokeWidth: 1.5 })), "SvgHistory"), er = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("circle", { cx: 6, cy: 6, r: 5.4, stroke: "currentColor", strokeWidth: 1.2, strokeDasharray: "4.241025 4.241025", transform: "rotate(22.5)", "transform-origin": "center" }), /* @__PURE__ */ c.createElement("circle", { cx: 6, cy: 6, r: 1, fill: "currentColor" })), "SvgImplements"), tr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M1.5 14.5653C1.5 15.211 1.75652 15.8303 2.21314 16.2869C2.66975 16.7435 3.28905 17 3.9348 17C4.58054 17 5.19984 16.7435 5.65646 16.2869C6.11307 15.8303 6.36959 15.211 6.36959 14.5653V12.1305H3.9348C3.28905 12.1305 2.66975 12.387 2.21314 12.8437C1.75652 13.3003 1.5 13.9195 1.5 14.5653Z", stroke: "currentColor", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ c.createElement("path", { d: "M3.9348 1.00063C3.28905 1.00063 2.66975 1.25715 2.21314 1.71375C1.75652 2.17035 1.5 2.78964 1.5 3.43537C1.5 4.0811 1.75652 4.70038 2.21314 5.15698C2.66975 5.61358 3.28905 5.8701 3.9348 5.8701H6.36959V3.43537C6.36959 2.78964 6.11307 2.17035 5.65646 1.71375C5.19984 1.25715 4.58054 1.00063 3.9348 1.00063Z", stroke: "currentColor", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ c.createElement("path", { d: "M15.0652 12.1305H12.6304V14.5653C12.6304 15.0468 12.7732 15.5175 13.0407 15.9179C13.3083 16.3183 13.6885 16.6304 14.1334 16.8147C14.5783 16.9989 15.0679 17.0472 15.5402 16.9532C16.0125 16.8593 16.4464 16.6274 16.7869 16.2869C17.1274 15.9464 17.3593 15.5126 17.4532 15.0403C17.5472 14.568 17.4989 14.0784 17.3147 13.6335C17.1304 13.1886 16.8183 12.8084 16.4179 12.5409C16.0175 12.2733 15.5468 12.1305 15.0652 12.1305Z", stroke: "currentColor", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ c.createElement("path", { d: "M12.6318 5.86775H6.36955V12.1285H12.6318V5.86775Z", stroke: "currentColor", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ c.createElement("path", { d: "M17.5 3.43473C17.5 2.789 17.2435 2.16972 16.7869 1.71312C16.3303 1.25652 15.711 1 15.0652 1C14.4195 1 13.8002 1.25652 13.3435 1.71312C12.8869 2.16972 12.6304 2.789 12.6304 3.43473V5.86946H15.0652C15.711 5.86946 16.3303 5.61295 16.7869 5.15635C17.2435 4.69975 17.5 4.08046 17.5 3.43473Z", stroke: "currentColor", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" })), "SvgKeyboardShortcut"), nr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("circle", { cx: 5, cy: 5, r: 4.35, stroke: "currentColor", strokeWidth: 1.3 }), /* @__PURE__ */ c.createElement("line", { x1: 8.45962, y1: 8.54038, x2: 11.7525, y2: 11.8333, stroke: "currentColor", strokeWidth: 1.3 })), "SvgMagnifyingGlass"), rr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "-2 -2 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M17.2492 6V2.9569C17.2492 1.73806 16.2611 0.75 15.0423 0.75L2.9569 0.75C1.73806 0.75 0.75 1.73806 0.75 2.9569L0.75 6", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ c.createElement("path", { d: "M0.749873 12V15.0431C0.749873 16.2619 1.73794 17.25 2.95677 17.25H15.0421C16.261 17.25 17.249 16.2619 17.249 15.0431V12", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ c.createElement("path", { d: "M6 4.5L9 7.5L12 4.5", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ c.createElement("path", { d: "M12 13.5L9 10.5L6 13.5", stroke: "currentColor", strokeWidth: 1.5 })), "SvgMerge"), or = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M0.75 13.25L0.0554307 12.967C-0.0593528 13.2488 0.00743073 13.5719 0.224488 13.7851C0.441545 13.9983 0.765869 14.0592 1.04549 13.9393L0.75 13.25ZM12.8214 1.83253L12.2911 2.36286L12.2911 2.36286L12.8214 1.83253ZM12.8214 3.90194L13.3517 4.43227L12.8214 3.90194ZM10.0981 1.17859L9.56773 0.648259L10.0981 1.17859ZM12.1675 1.17859L12.6978 0.648258L12.6978 0.648257L12.1675 1.17859ZM2.58049 8.75697L3.27506 9.03994L2.58049 8.75697ZM2.70066 8.57599L3.23099 9.10632L2.70066 8.57599ZM5.2479 11.4195L4.95355 10.7297L5.2479 11.4195ZM5.42036 11.303L4.89003 10.7727L5.42036 11.303ZM4.95355 10.7297C4.08882 11.0987 3.41842 11.362 2.73535 11.6308C2.05146 11.9 1.35588 12.1743 0.454511 12.5607L1.04549 13.9393C1.92476 13.5624 2.60256 13.2951 3.28469 13.0266C3.96762 12.7578 4.65585 12.4876 5.54225 12.1093L4.95355 10.7297ZM1.44457 13.533L3.27506 9.03994L1.88592 8.474L0.0554307 12.967L1.44457 13.533ZM3.23099 9.10632L10.6284 1.70892L9.56773 0.648259L2.17033 8.04566L3.23099 9.10632ZM11.6371 1.70892L12.2911 2.36286L13.3517 1.3022L12.6978 0.648258L11.6371 1.70892ZM12.2911 3.37161L4.89003 10.7727L5.95069 11.8333L13.3517 4.43227L12.2911 3.37161ZM12.2911 2.36286C12.5696 2.64142 12.5696 3.09305 12.2911 3.37161L13.3517 4.43227C14.2161 3.56792 14.2161 2.16654 13.3517 1.3022L12.2911 2.36286ZM10.6284 1.70892C10.9069 1.43036 11.3586 1.43036 11.6371 1.70892L12.6978 0.648257C11.8335 -0.216088 10.4321 -0.216084 9.56773 0.648259L10.6284 1.70892ZM3.27506 9.03994C3.26494 9.06479 3.24996 9.08735 3.23099 9.10632L2.17033 8.04566C2.04793 8.16806 1.95123 8.31369 1.88592 8.474L3.27506 9.03994ZM5.54225 12.1093C5.69431 12.0444 5.83339 11.9506 5.95069 11.8333L4.89003 10.7727C4.90863 10.7541 4.92988 10.7398 4.95355 10.7297L5.54225 12.1093Z", fill: "currentColor" }), /* @__PURE__ */ c.createElement("path", { d: "M11.5 4.5L9.5 2.5", stroke: "currentColor", strokeWidth: 1.4026, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ c.createElement("path", { d: "M5.5 10.5L3.5 8.5", stroke: "currentColor", strokeWidth: 1.4026, strokeLinecap: "round", strokeLinejoin: "round" })), "SvgPen"), lr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 16 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M1.32226e-07 1.6609C7.22332e-08 0.907329 0.801887 0.424528 1.46789 0.777117L15.3306 8.11621C16.0401 8.49182 16.0401 9.50818 15.3306 9.88379L1.46789 17.2229C0.801886 17.5755 1.36076e-06 17.0927 1.30077e-06 16.3391L1.32226e-07 1.6609Z", fill: "currentColor" })), "SvgPlay"), ir = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 10 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 9.25V13.5H5.75V9.25L10 9.25V7.75L5.75 7.75V3.5H4.25V7.75L0 7.75V9.25L4.25 9.25Z" })), "SvgPlus"), sr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M10.2852 24.0745L13.7139 18.0742", stroke: "currentColor", strokeWidth: 1.5625 }), /* @__PURE__ */ c.createElement("path", { d: "M14.5742 24.0749L17.1457 19.7891", stroke: "currentColor", strokeWidth: 1.5625 }), /* @__PURE__ */ c.createElement("path", { d: "M19.4868 24.0735L20.7229 21.7523C21.3259 20.6143 21.5457 19.3122 21.3496 18.0394C21.1535 16.7666 20.5519 15.591 19.6342 14.6874L23.7984 6.87853C24.0123 6.47728 24.0581 6.00748 23.9256 5.57249C23.7932 5.1375 23.4933 4.77294 23.0921 4.55901C22.6908 4.34509 22.221 4.29932 21.7861 4.43178C21.3511 4.56424 20.9865 4.86408 20.7726 5.26533L16.6084 13.0742C15.3474 12.8142 14.0362 12.9683 12.8699 13.5135C11.7035 14.0586 10.7443 14.9658 10.135 16.1L6 24.0735", stroke: "currentColor", strokeWidth: 1.5625 }), /* @__PURE__ */ c.createElement("path", { d: "M4 15L5 13L7 12L5 11L4 9L3 11L1 12L3 13L4 15Z", stroke: "currentColor", strokeWidth: 1.5625, strokeLinejoin: "round" }), /* @__PURE__ */ c.createElement("path", { d: "M11.5 8L12.6662 5.6662L15 4.5L12.6662 3.3338L11.5 1L10.3338 3.3338L8 4.5L10.3338 5.6662L11.5 8Z", stroke: "currentColor", strokeWidth: 1.5625, strokeLinejoin: "round" })), "SvgPrettify"), ar = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M4.75 9.25H1.25V12.75", stroke: "currentColor", strokeWidth: 1, strokeLinecap: "square" }), /* @__PURE__ */ c.createElement("path", { d: "M11.25 6.75H14.75V3.25", stroke: "currentColor", strokeWidth: 1, strokeLinecap: "square" }), /* @__PURE__ */ c.createElement("path", { d: "M14.1036 6.65539C13.8 5.27698 13.0387 4.04193 11.9437 3.15131C10.8487 2.26069 9.48447 1.76694 8.0731 1.75043C6.66173 1.73392 5.28633 2.19563 4.17079 3.0604C3.05526 3.92516 2.26529 5.14206 1.92947 6.513", stroke: "currentColor", strokeWidth: 1 }), /* @__PURE__ */ c.createElement("path", { d: "M1.89635 9.34461C2.20001 10.723 2.96131 11.9581 4.05631 12.8487C5.15131 13.7393 6.51553 14.2331 7.9269 14.2496C9.33827 14.2661 10.7137 13.8044 11.8292 12.9396C12.9447 12.0748 13.7347 10.8579 14.0705 9.487", stroke: "currentColor", strokeWidth: 1 })), "SvgReload"), cr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("rect", { x: 0.6, y: 0.6, width: 11.8, height: 11.8, rx: 5.9, stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("path", { d: "M4.25 7.5C4.25 6 5.75 5 6.5 6.5C7.25 8 8.75 7 8.75 5.5", stroke: "currentColor", strokeWidth: 1.2 })), "SvgRootType"), ur = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.29186 1.92702C9.06924 1.82745 8.87014 1.68202 8.70757 1.50024L7.86631 0.574931C7.62496 0.309957 7.30773 0.12592 6.95791 0.0479385C6.60809 -0.0300431 6.24274 0.00182978 5.91171 0.139208C5.58068 0.276585 5.3001 0.512774 5.10828 0.815537C4.91645 1.1183 4.82272 1.47288 4.83989 1.83089L4.90388 3.08019C4.91612 3.32348 4.87721 3.56662 4.78968 3.79394C4.70215 4.02126 4.56794 4.2277 4.39571 4.39994C4.22347 4.57219 4.01704 4.7064 3.78974 4.79394C3.56243 4.88147 3.3193 4.92038 3.07603 4.90814L1.8308 4.84414C1.47162 4.82563 1.11553 4.91881 0.811445 5.11086C0.507359 5.30292 0.270203 5.58443 0.132561 5.91671C-0.00508149 6.249 -0.0364554 6.61576 0.0427496 6.9666C0.121955 7.31744 0.307852 7.63514 0.5749 7.87606L1.50016 8.71204C1.68193 8.87461 1.82735 9.07373 1.92692 9.29636C2.02648 9.51898 2.07794 9.76012 2.07794 10.004C2.07794 10.2479 2.02648 10.489 1.92692 10.7116C1.82735 10.9343 1.68193 11.1334 1.50016 11.296L0.5749 12.1319C0.309856 12.3729 0.125575 12.6898 0.0471809 13.0393C-0.0312128 13.3888 9.64098e-05 13.754 0.13684 14.0851C0.273583 14.4162 0.509106 14.6971 0.811296 14.8894C1.11349 15.0817 1.46764 15.1762 1.82546 15.1599L3.0707 15.0959C3.31397 15.0836 3.5571 15.1225 3.7844 15.2101C4.01171 15.2976 4.21814 15.4318 4.39037 15.6041C4.56261 15.7763 4.69682 15.9827 4.78435 16.2101C4.87188 16.4374 4.91078 16.6805 4.89855 16.9238L4.83455 18.1691C4.81605 18.5283 4.90921 18.8844 5.10126 19.1885C5.2933 19.4926 5.5748 19.7298 5.90707 19.8674C6.23934 20.0051 6.60608 20.0365 6.9569 19.9572C7.30772 19.878 7.6254 19.6921 7.86631 19.4251L8.7129 18.4998C8.87547 18.318 9.07458 18.1725 9.29719 18.073C9.51981 17.9734 9.76093 17.9219 10.0048 17.9219C10.2487 17.9219 10.4898 17.9734 10.7124 18.073C10.935 18.1725 11.1341 18.318 11.2967 18.4998L12.1326 19.4251C12.3735 19.6921 12.6912 19.878 13.042 19.9572C13.3929 20.0365 13.7596 20.0051 14.0919 19.8674C14.4241 19.7298 14.7056 19.4926 14.8977 19.1885C15.0897 18.8844 15.1829 18.5283 15.1644 18.1691L15.1004 16.9238C15.0882 16.6805 15.1271 16.4374 15.2146 16.2101C15.3021 15.9827 15.4363 15.7763 15.6086 15.6041C15.7808 15.4318 15.9872 15.2976 16.2145 15.2101C16.4418 15.1225 16.685 15.0836 16.9282 15.0959L18.1735 15.1599C18.5326 15.1784 18.8887 15.0852 19.1928 14.8931C19.4969 14.7011 19.7341 14.4196 19.8717 14.0873C20.0093 13.755 20.0407 13.3882 19.9615 13.0374C19.8823 12.6866 19.6964 12.3689 19.4294 12.1279L18.5041 11.292C18.3223 11.1294 18.1769 10.9303 18.0774 10.7076C17.9778 10.485 17.9263 10.2439 17.9263 10C17.9263 9.75612 17.9778 9.51499 18.0774 9.29236C18.1769 9.06973 18.3223 8.87062 18.5041 8.70804L19.4294 7.87206C19.6964 7.63114 19.8823 7.31344 19.9615 6.9626C20.0407 6.61176 20.0093 6.245 19.8717 5.91271C19.7341 5.58043 19.4969 5.29892 19.1928 5.10686C18.8887 4.91481 18.5326 4.82163 18.1735 4.84014L16.9282 4.90414C16.685 4.91638 16.4418 4.87747 16.2145 4.78994C15.9872 4.7024 15.7808 4.56818 15.6086 4.39594C15.4363 4.2237 15.3021 4.01726 15.2146 3.78994C15.1271 3.56262 15.0882 3.31948 15.1004 3.07619L15.1644 1.83089C15.1829 1.4717 15.0897 1.11559 14.8977 0.811487C14.7056 0.507385 14.4241 0.270217 14.0919 0.132568C13.7596 -0.00508182 13.3929 -0.0364573 13.042 0.0427519C12.6912 0.121961 12.3735 0.307869 12.1326 0.574931L11.2914 1.50024C11.1288 1.68202 10.9297 1.82745 10.7071 1.92702C10.4845 2.02659 10.2433 2.07805 9.99947 2.07805C9.7556 2.07805 9.51448 2.02659 9.29186 1.92702ZM14.3745 10C14.3745 12.4162 12.4159 14.375 9.99977 14.375C7.58365 14.375 5.625 12.4162 5.625 10C5.625 7.58375 7.58365 5.625 9.99977 5.625C12.4159 5.625 14.3745 7.58375 14.3745 10Z", fill: "currentColor" })), "SvgSettings"), dr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M6.5782 1.07092C6.71096 0.643026 7.28904 0.643027 7.4218 1.07092L8.59318 4.84622C8.65255 5.03758 8.82284 5.16714 9.01498 5.16714L12.8056 5.16714C13.2353 5.16714 13.4139 5.74287 13.0663 6.00732L9.99962 8.34058C9.84418 8.45885 9.77913 8.66848 9.83851 8.85984L11.0099 12.6351C11.1426 13.063 10.675 13.4189 10.3274 13.1544L7.26069 10.8211C7.10524 10.7029 6.89476 10.7029 6.73931 10.8211L3.6726 13.1544C3.32502 13.4189 2.85735 13.063 2.99012 12.6351L4.16149 8.85984C4.22087 8.66848 4.15582 8.45885 4.00038 8.34058L0.933671 6.00732C0.586087 5.74287 0.764722 5.16714 1.19436 5.16714L4.98502 5.16714C5.17716 5.16714 5.34745 5.03758 5.40682 4.84622L6.5782 1.07092Z", fill: "currentColor", stroke: "currentColor" })), "SvgStarFilled"), hr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M6.5782 1.07092C6.71096 0.643026 7.28904 0.643027 7.4218 1.07092L8.59318 4.84622C8.65255 5.03758 8.82284 5.16714 9.01498 5.16714L12.8056 5.16714C13.2353 5.16714 13.4139 5.74287 13.0663 6.00732L9.99962 8.34058C9.84418 8.45885 9.77913 8.66848 9.83851 8.85984L11.0099 12.6351C11.1426 13.063 10.675 13.4189 10.3274 13.1544L7.26069 10.8211C7.10524 10.7029 6.89476 10.7029 6.73931 10.8211L3.6726 13.1544C3.32502 13.4189 2.85735 13.063 2.99012 12.6351L4.16149 8.85984C4.22087 8.66848 4.15582 8.45885 4.00038 8.34058L0.933671 6.00732C0.586087 5.74287 0.764722 5.16714 1.19436 5.16714L4.98502 5.16714C5.17716 5.16714 5.34745 5.03758 5.40682 4.84622L6.5782 1.07092Z", stroke: "currentColor", strokeWidth: 1.5 })), "SvgStar"), mr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("rect", { width: 16, height: 16, rx: 2, fill: "currentColor" })), "SvgStop"), fr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { width: "1em", height: "5em", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", "aria-hidden": "true", viewBox: "0 0 23 23", style: {
  height: "1.5em"
}, clipRule: "evenodd", "aria-labelledby": t, ...n }, e === void 0 ? /* @__PURE__ */ c.createElement("title", { id: t }, "trash icon") : e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("path", { d: "M19 24h-14c-1.104 0-2-.896-2-2v-17h-1v-2h6v-1.5c0-.827.673-1.5 1.5-1.5h5c.825 0 1.5.671 1.5 1.5v1.5h6v2h-1v17c0 1.104-.896 2-2 2zm0-19h-14v16.5c0 .276.224.5.5.5h13c.276 0 .5-.224.5-.5v-16.5zm-7 7.586l3.293-3.293 1.414 1.414-3.293 3.293 3.293 3.293-1.414 1.414-3.293-3.293-3.293 3.293-1.414-1.414 3.293-3.293-3.293-3.293 1.414-1.414 3.293 3.293zm2-10.586h-4v1h4v-1z", fill: "currentColor", strokeWidth: 0.25, stroke: "currentColor" })), "SvgTrash"), pr = /* @__PURE__ */ s(({
  title: e,
  titleId: t,
  ...n
}) => /* @__PURE__ */ c.createElement("svg", { height: "1em", viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ c.createElement("title", { id: t }, e) : null, /* @__PURE__ */ c.createElement("rect", { x: 0.6, y: 0.6, width: 11.8, height: 11.8, rx: 5.9, stroke: "currentColor", strokeWidth: 1.2 }), /* @__PURE__ */ c.createElement("rect", { x: 5.5, y: 5.5, width: 2, height: 2, rx: 1, fill: "currentColor" })), "SvgType"), gr = D(Fn), Uo = D(Bn), Cr = D(Wn), Ko = D(_n), st = D($n), Jo = D(Zn), vr = D(Gn), yr = D(Qn), br = D(jn), wr = D(zn), xr = D(Un, "filled docs icon"), Er = D(Kn), Lr = D(Jn), Sr = D(Yn), Nr = D(Xn), kr = D(er), Yo = D(tr), Tr = D(nr), Xo = D(rr), Mr = D(or), Vr = D(lr), el = D(ir), tl = D(sr), nl = D(ar), Hr = D(cr), rl = D(ur), Ar = D(dr, "filled star icon"), qr = D(hr), Rr = D(mr), Dr = D(fr, "trash icon"), ke = D(pr);
function D(e, t = e.name.replace("Svg", "").replaceAll(/([A-Z])/g, " $1").trimStart().toLowerCase() + " icon") {
  function n(r) {
    return /* @__PURE__ */ o(e, { title: t, ...r });
  }
  return s(n, "IconComponent"), n.displayName = e.name, n;
}
s(D, "generateIcon");
const J = K((e, t) => /* @__PURE__ */ o(
  "button",
  {
    ...e,
    ref: t,
    className: Q("graphiql-un-styled", e.className)
  }
));
J.displayName = "UnStyledButton";
const Le = K((e, t) => /* @__PURE__ */ o(
  "button",
  {
    ...e,
    ref: t,
    className: Q(
      "graphiql-button",
      {
        success: "graphiql-button-success",
        error: "graphiql-button-error"
      }[e.state],
      e.className
    )
  }
));
Le.displayName = "Button";
const Pr = K((e, t) => /* @__PURE__ */ o(
  "div",
  {
    ...e,
    ref: t,
    className: Q("graphiql-button-group", e.className)
  }
));
Pr.displayName = "ButtonGroup";
const Se = /* @__PURE__ */ s((e, t) => Object.entries(t).reduce((n, [r, l]) => (n[r] = l, n), e), "createComponentGroup");
const qt = K((e, t) => /* @__PURE__ */ o(oe.Close, { asChild: !0, children: /* @__PURE__ */ T(
  J,
  {
    ...e,
    ref: t,
    type: "button",
    className: Q("graphiql-dialog-close", e.className),
    children: [
      /* @__PURE__ */ o(Hn, { children: "Close dialog" }),
      /* @__PURE__ */ o(st, {})
    ]
  }
) }));
qt.displayName = "Dialog.Close";
function Ir({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ o(oe.Root, { ...t, children: /* @__PURE__ */ T(oe.Portal, { children: [
    /* @__PURE__ */ o(oe.Overlay, { className: "graphiql-dialog-overlay" }),
    /* @__PURE__ */ o(oe.Content, { className: "graphiql-dialog", children: e })
  ] }) });
}
s(Ir, "DialogRoot");
const ol = Se(Ir, {
  Close: qt,
  Title: oe.Title,
  Trigger: oe.Trigger,
  Description: oe.Description
});
const Rt = K(
  (e, t) => /* @__PURE__ */ o(An, { asChild: !0, children: /* @__PURE__ */ o(
    "button",
    {
      ...e,
      ref: t,
      className: Q("graphiql-un-styled", e.className)
    }
  ) })
);
Rt.displayName = "DropdownMenuButton";
function Or({
  children: e,
  align: t = "start",
  sideOffset: n = 5,
  className: r,
  ...l
}) {
  return /* @__PURE__ */ o(Rn, { children: /* @__PURE__ */ o(
    Dn,
    {
      align: t,
      sideOffset: n,
      className: Q("graphiql-dropdown-content", r),
      ...l,
      children: e
    }
  ) });
}
s(Or, "Content");
const Fr = /* @__PURE__ */ s(({ className: e, children: t, ...n }) => /* @__PURE__ */ o(Pn, { className: Q("graphiql-dropdown-item", e), ...n, children: t }), "Item"), le = Se(qn, {
  Button: Rt,
  Item: Fr,
  Content: Or
}), qe = new In({
  breaks: !0,
  linkify: !0
});
const te = K(({ children: e, onlyShowFirstChild: t, type: n, ...r }, l) => /* @__PURE__ */ o(
  "div",
  {
    ...r,
    ref: l,
    className: Q(
      `graphiql-markdown-${n}`,
      t && "graphiql-markdown-preview",
      r.className
    ),
    dangerouslySetInnerHTML: { __html: qe.render(e) }
  }
));
te.displayName = "MarkdownContent";
const Dt = K(
  (e, t) => /* @__PURE__ */ o(
    "div",
    {
      ...e,
      ref: t,
      className: Q("graphiql-spinner", e.className)
    }
  )
);
Dt.displayName = "Spinner";
function Br({
  children: e,
  align: t = "start",
  side: n = "bottom",
  sideOffset: r = 5,
  label: l
}) {
  return /* @__PURE__ */ T(ge.Root, { children: [
    /* @__PURE__ */ o(ge.Trigger, { asChild: !0, children: e }),
    /* @__PURE__ */ o(ge.Portal, { children: /* @__PURE__ */ o(
      ge.Content,
      {
        className: "graphiql-tooltip",
        align: t,
        side: n,
        sideOffset: r,
        children: l
      }
    ) })
  ] });
}
s(Br, "TooltipRoot");
const ne = Se(Br, {
  Provider: ge.Provider
});
const Pt = K(
  ({ isActive: e, value: t, children: n, className: r, ...l }, a) => /* @__PURE__ */ o(
    Ht.Item,
    {
      ...l,
      ref: a,
      value: t,
      "aria-selected": e ? "true" : void 0,
      role: "tab",
      className: Q(
        "graphiql-tab",
        e && "graphiql-tab-active",
        r
      ),
      children: n
    }
  )
);
Pt.displayName = "Tab";
const It = K((e, t) => /* @__PURE__ */ o(
  J,
  {
    ...e,
    ref: t,
    type: "button",
    className: Q("graphiql-tab-button", e.className),
    children: e.children
  }
));
It.displayName = "Tab.Button";
const Ot = K(
  (e, t) => /* @__PURE__ */ o(ne, { label: "Close Tab", children: /* @__PURE__ */ o(
    J,
    {
      "aria-label": "Close Tab",
      ...e,
      ref: t,
      type: "button",
      className: Q("graphiql-tab-close", e.className),
      children: /* @__PURE__ */ o(st, {})
    }
  ) })
);
Ot.displayName = "Tab.Close";
const ll = Se(Pt, {
  Button: It,
  Close: Ot
}), Wr = K(
  ({ values: e, onReorder: t, children: n, className: r, ...l }, a) => /* @__PURE__ */ o(
    Ht.Group,
    {
      ...l,
      ref: a,
      values: e,
      onReorder: t,
      axis: "x",
      role: "tablist",
      className: Q("graphiql-tabs", r),
      children: n
    }
  )
);
Wr.displayName = "Tabs";
const Ft = ae("HistoryContext");
function _r(e) {
  var y;
  const t = ue(), n = B(
    new wn(
      // Fall back to a noop storage when the StorageContext is empty
      t || new Ye(null),
      e.maxHistoryLength || $r
    )
  ), [r, l] = I(((y = n.current) == null ? void 0 : y.queries) || []), a = N(
    (d) => {
      var g;
      (g = n.current) == null || g.updateHistory(d), l(n.current.queries);
    },
    []
  ), i = N(
    (d, g) => {
      n.current.editLabel(d, g), l(n.current.queries);
    },
    []
  ), u = N(
    (d) => {
      n.current.toggleFavorite(d), l(n.current.queries);
    },
    []
  ), p = N(
    (d) => d,
    []
  ), h = N((d, g = !1) => {
    n.current.deleteHistory(d, g), l(n.current.queries);
  }, []), f = G(
    () => ({
      addToHistory: a,
      editLabel: i,
      items: r,
      toggleFavorite: u,
      setActive: p,
      deleteFromHistory: h
    }),
    [
      a,
      i,
      r,
      u,
      p,
      h
    ]
  );
  return /* @__PURE__ */ o(Ft.Provider, { value: f, children: e.children });
}
s(_r, "HistoryContextProvider");
const Be = ce(Ft), $r = 20;
function Zr() {
  const { items: e, deleteFromHistory: t } = Be({
    nonNull: !0
  });
  let n = e.slice().map((u, p) => ({ ...u, index: p })).reverse();
  const r = n.filter((u) => u.favorite);
  r.length && (n = n.filter((u) => !u.favorite));
  const [l, a] = I(
    null
  );
  R(() => {
    l && setTimeout(() => {
      a(null);
    }, 2e3);
  }, [l]);
  const i = N(() => {
    try {
      for (const u of n)
        t(u, !0);
      a("success");
    } catch {
      a("error");
    }
  }, [t, n]);
  return /* @__PURE__ */ T("section", { "aria-label": "History", className: "graphiql-history", children: [
    /* @__PURE__ */ T("div", { className: "graphiql-history-header", children: [
      "History",
      (l || n.length > 0) && /* @__PURE__ */ o(
        Le,
        {
          type: "button",
          state: l || void 0,
          disabled: !n.length,
          onClick: i,
          children: {
            success: "Cleared",
            error: "Failed to Clear"
          }[l] || "Clear"
        }
      )
    ] }),
    !!r.length && /* @__PURE__ */ o("ul", { className: "graphiql-history-items", children: r.map((u) => /* @__PURE__ */ o(Re, { item: u }, u.index)) }),
    !!r.length && !!n.length && /* @__PURE__ */ o("div", { className: "graphiql-history-item-spacer" }),
    !!n.length && /* @__PURE__ */ o("ul", { className: "graphiql-history-items", children: n.map((u) => /* @__PURE__ */ o(Re, { item: u }, u.index)) })
  ] });
}
s(Zr, "History");
function Re(e) {
  const { editLabel: t, toggleFavorite: n, deleteFromHistory: r, setActive: l } = Be({
    nonNull: !0,
    caller: Re
  }), { headerEditor: a, queryEditor: i, variableEditor: u } = j({
    nonNull: !0,
    caller: Re
  }), p = B(null), h = B(null), [f, y] = I(!1);
  R(() => {
    var b;
    f && ((b = p.current) == null || b.focus());
  }, [f]);
  const d = e.item.label || e.item.operationName || Gr(e.item.query), g = N(() => {
    var V;
    y(!1);
    const { index: b, ...w } = e.item;
    t({ ...w, label: (V = p.current) == null ? void 0 : V.value }, b);
  }, [t, e.item]), m = N(() => {
    y(!1);
  }, []), C = N(
    (b) => {
      b.stopPropagation(), y(!0);
    },
    []
  ), x = N(() => {
    const { query: b, variables: w, headers: V } = e.item;
    i == null || i.setValue(b ?? ""), u == null || u.setValue(w ?? ""), a == null || a.setValue(V ?? ""), l(e.item);
  }, [a, e.item, i, l, u]), k = N(
    (b) => {
      b.stopPropagation(), r(e.item);
    },
    [e.item, r]
  ), L = N(
    (b) => {
      b.stopPropagation(), n(e.item);
    },
    [e.item, n]
  );
  return /* @__PURE__ */ o("li", { className: Q("graphiql-history-item", f && "editable"), children: f ? /* @__PURE__ */ T(z, { children: [
    /* @__PURE__ */ o(
      "input",
      {
        type: "text",
        defaultValue: e.item.label,
        ref: p,
        onKeyDown: (b) => {
          b.key === "Esc" ? y(!1) : b.key === "Enter" && (y(!1), t({ ...e.item, label: b.currentTarget.value }));
        },
        placeholder: "Type a label"
      }
    ),
    /* @__PURE__ */ o(J, { type: "button", ref: h, onClick: g, children: "Save" }),
    /* @__PURE__ */ o(J, { type: "button", ref: h, onClick: m, children: /* @__PURE__ */ o(st, {}) })
  ] }) : /* @__PURE__ */ T(z, { children: [
    /* @__PURE__ */ o(ne, { label: "Set active", children: /* @__PURE__ */ o(
      J,
      {
        type: "button",
        className: "graphiql-history-item-label",
        onClick: x,
        "aria-label": "Set active",
        children: d
      }
    ) }),
    /* @__PURE__ */ o(ne, { label: "Edit label", children: /* @__PURE__ */ o(
      J,
      {
        type: "button",
        className: "graphiql-history-item-action",
        onClick: C,
        "aria-label": "Edit label",
        children: /* @__PURE__ */ o(Mr, { "aria-hidden": "true" })
      }
    ) }),
    /* @__PURE__ */ o(
      ne,
      {
        label: e.item.favorite ? "Remove favorite" : "Add favorite",
        children: /* @__PURE__ */ o(
          J,
          {
            type: "button",
            className: "graphiql-history-item-action",
            onClick: L,
            "aria-label": e.item.favorite ? "Remove favorite" : "Add favorite",
            children: e.item.favorite ? /* @__PURE__ */ o(Ar, { "aria-hidden": "true" }) : /* @__PURE__ */ o(qr, { "aria-hidden": "true" })
          }
        )
      }
    ),
    /* @__PURE__ */ o(ne, { label: "Delete from history", children: /* @__PURE__ */ o(
      J,
      {
        type: "button",
        className: "graphiql-history-item-action",
        onClick: k,
        "aria-label": "Delete from history",
        children: /* @__PURE__ */ o(Dr, { "aria-hidden": "true" })
      }
    ) })
  ] }) });
}
s(Re, "HistoryItem");
function Gr(e) {
  return e == null ? void 0 : e.split(`
`).map((t) => t.replace(/#(.*)/, "")).join(" ").replaceAll("{", " { ").replaceAll("}", " } ").replaceAll(/[\s]{2,}/g, " ");
}
s(Gr, "formatQuery");
const Bt = ae("ExecutionContext");
function et({
  fetcher: e,
  getDefaultFieldNames: t,
  children: n,
  operationName: r
}) {
  if (!e)
    throw new TypeError(
      "The `ExecutionContextProvider` component requires a `fetcher` function to be passed as prop."
    );
  const {
    externalFragments: l,
    headerEditor: a,
    queryEditor: i,
    responseEditor: u,
    variableEditor: p,
    updateActiveTabValues: h
  } = j({ nonNull: !0, caller: et }), f = Be(), y = ot({
    getDefaultFieldNames: t,
    caller: et
  }), [d, g] = I(!1), [m, C] = I(null), x = B(0), k = N(() => {
    m == null || m.unsubscribe(), g(!1), C(null);
  }, [m]), L = N(async () => {
    if (!i || !u)
      return;
    if (m) {
      k();
      return;
    }
    const V = /* @__PURE__ */ s((M) => {
      u.setValue(M), h({ response: M });
    }, "setResponse");
    x.current += 1;
    const W = x.current;
    let $ = y() || i.getValue();
    const P = p == null ? void 0 : p.getValue();
    let O;
    try {
      O = gt({
        json: P,
        errorMessageParse: "Variables are invalid JSON",
        errorMessageType: "Variables are not a JSON object."
      });
    } catch (M) {
      V(M instanceof Error ? M.message : `${M}`);
      return;
    }
    const _ = a == null ? void 0 : a.getValue();
    let F;
    try {
      F = gt({
        json: _,
        errorMessageParse: "Headers are invalid JSON",
        errorMessageType: "Headers are not a JSON object."
      });
    } catch (M) {
      V(M instanceof Error ? M.message : `${M}`);
      return;
    }
    if (l) {
      const M = i.documentAST ? kn(
        i.documentAST,
        l
      ) : [];
      M.length > 0 && ($ += `
` + M.map((H) => Oe(H)).join(`
`));
    }
    V(""), g(!0);
    const A = r ?? i.operationName ?? void 0;
    f == null || f.addToHistory({
      query: $,
      variables: P,
      headers: _,
      operationName: A
    });
    try {
      const M = {}, H = /* @__PURE__ */ s((v) => {
        if (W !== x.current)
          return;
        let S = Array.isArray(v) ? v : !1;
        if (!S && typeof v == "object" && v !== null && "hasNext" in v && (S = [v]), S) {
          for (const q of S)
            Wt(M, q);
          g(!1), V(Xe(M));
        } else {
          const q = Xe(v);
          g(!1), V(q);
        }
      }, "handleResponse"), E = e(
        {
          query: $,
          variables: O,
          operationName: A
        },
        {
          headers: F ?? void 0,
          documentAST: i.documentAST ?? void 0
        }
      ), Z = await Promise.resolve(E);
      if (xn(Z))
        C(
          Z.subscribe({
            next(v) {
              H(v);
            },
            error(v) {
              g(!1), v && V(ve(v)), C(null);
            },
            complete() {
              g(!1), C(null);
            }
          })
        );
      else if (En(Z)) {
        C({
          unsubscribe: () => {
            var v, S;
            return (S = (v = Z[Symbol.asyncIterator]()).return) == null ? void 0 : S.call(v);
          }
        });
        for await (const v of Z)
          H(v);
        g(!1), C(null);
      } else
        H(Z);
    } catch (M) {
      g(!1), V(ve(M)), C(null);
    }
  }, [
    y,
    l,
    e,
    a,
    f,
    r,
    i,
    u,
    k,
    m,
    h,
    p
  ]), b = !!m, w = G(
    () => ({
      isFetching: d,
      isSubscribed: b,
      operationName: r ?? null,
      run: L,
      stop: k
    }),
    [d, b, r, L, k]
  );
  return /* @__PURE__ */ o(Bt.Provider, { value: w, children: n });
}
s(et, "ExecutionContextProvider");
const We = ce(Bt);
function gt({
  json: e,
  errorMessageParse: t,
  errorMessageType: n
}) {
  let r;
  try {
    r = e && e.trim() !== "" ? JSON.parse(e) : void 0;
  } catch (a) {
    throw new Error(
      `${t}: ${a instanceof Error ? a.message : a}.`
    );
  }
  const l = typeof r == "object" && r !== null && !Array.isArray(r);
  if (r !== void 0 && !l)
    throw new Error(n);
  return r;
}
s(gt, "tryParseJsonObject");
function Wt(e, t) {
  const n = ["data", ...t.path ?? []];
  if (t.items)
    for (const r of t.items)
      je(e, n.join("."), r), n[n.length - 1]++;
  if (t.data && je(e, n.join("."), t.data, {
    merge: !0
  }), t.errors && (e.errors || (e.errors = []), e.errors.push(
    ...t.errors
  )), t.extensions && je(e, "extensions", t.extensions, {
    merge: !0
  }), t.incremental)
    for (const r of t.incremental)
      Wt(e, r);
}
s(Wt, "mergeIncrementalResult");
const _e = "graphiql", $e = "sublime";
let _t = !1;
typeof window == "object" && (_t = window.navigator.platform.toLowerCase().indexOf("mac") === 0);
const Ze = {
  // Persistent search box in Query Editor
  [_t ? "Cmd-F" : "Ctrl-F"]: "findPersistent",
  "Cmd-G": "findPersistent",
  "Ctrl-G": "findPersistent",
  // Editor improvements
  "Ctrl-Left": "goSubwordLeft",
  "Ctrl-Right": "goSubwordRight",
  "Alt-Left": "goGroupLeft",
  "Alt-Right": "goGroupRight"
};
async function Ne(e, t) {
  const n = await import("./codemirror.es.js").then((r) => r.c).then(
    (r) => (
      // Depending on bundler and settings the dynamic import either returns a
      // function (e.g. parcel) or an object containing a `default` property
      typeof r == "function" ? r : r.default
    )
  );
  return await Promise.all(
    (t == null ? void 0 : t.useCommonAddons) === !1 ? e : [
      import("./show-hint.es.js").then((r) => r.s),
      import("./matchbrackets.es.js").then((r) => r.m),
      import("./closebrackets.es.js").then((r) => r.c),
      import("./brace-fold.es.js").then((r) => r.b),
      import("./foldgutter.es.js").then((r) => r.f),
      import("./lint.es.js").then((r) => r.l),
      import("./searchcursor.es.js").then((r) => r.s),
      import("./jump-to-line.es.js").then((r) => r.j),
      import("./dialog.es.js").then((r) => r.d),
      // @ts-expect-error
      import("./sublime.es.js").then((r) => r.s),
      ...e
    ]
  ), n;
}
s(Ne, "importCodeMirror");
const Qr = /* @__PURE__ */ s((e) => e ? Oe(e) : "", "printDefault");
function $t({ field: e }) {
  if (!("defaultValue" in e) || e.defaultValue === void 0)
    return null;
  const t = hn(e.defaultValue, e.type);
  return t ? /* @__PURE__ */ T(z, { children: [
    " = ",
    /* @__PURE__ */ o("span", { className: "graphiql-doc-explorer-default-value", children: Qr(t) })
  ] }) : null;
}
s($t, "DefaultValue");
const Zt = ae("SchemaContext");
function Gt(e) {
  if (!e.fetcher)
    throw new TypeError(
      "The `SchemaContextProvider` component requires a `fetcher` function to be passed as prop."
    );
  const { initialHeaders: t, headerEditor: n } = j({
    nonNull: !0,
    caller: Gt
  }), [r, l] = I(), [a, i] = I(!1), [u, p] = I(null), h = B(0);
  R(() => {
    l(
      ht(e.schema) || e.schema === null || e.schema === void 0 ? e.schema : void 0
    ), h.current++;
  }, [e.schema]);
  const f = B(t);
  R(() => {
    n && (f.current = n.getValue());
  });
  const {
    introspectionQuery: y,
    introspectionQueryName: d,
    introspectionQuerySansSubscriptions: g
  } = jr({
    inputValueDeprecation: e.inputValueDeprecation,
    introspectionQueryName: e.introspectionQueryName,
    schemaDescription: e.schemaDescription
  }), { fetcher: m, onSchemaChange: C, dangerouslyAssumeSchemaIsValid: x, children: k } = e, L = N(() => {
    if (ht(e.schema) || e.schema === null)
      return;
    const V = ++h.current, W = e.schema;
    async function $() {
      if (W)
        return W;
      const P = zr(f.current);
      if (!P.isValidJSON) {
        p("Introspection failed as headers are invalid.");
        return;
      }
      const O = P.headers ? { headers: P.headers } : {}, _ = mt(
        m(
          {
            query: y,
            operationName: d
          },
          O
        )
      );
      if (!ft(_)) {
        p("Fetcher did not return a Promise for introspection.");
        return;
      }
      i(!0), p(null);
      let F = await _;
      if (typeof F != "object" || F === null || !("data" in F)) {
        const M = mt(
          m(
            {
              query: g,
              operationName: d
            },
            O
          )
        );
        if (!ft(M))
          throw new Error(
            "Fetcher did not return a Promise for introspection."
          );
        F = await M;
      }
      if (i(!1), F != null && F.data && "__schema" in F.data)
        return F.data;
      const A = typeof F == "string" ? F : Xe(F);
      p(A);
    }
    s($, "fetchIntrospectionData"), $().then((P) => {
      if (!(V !== h.current || !P))
        try {
          const O = mn(P);
          l(O), C == null || C(O);
        } catch (O) {
          p(ve(O));
        }
    }).catch((P) => {
      V === h.current && (p(ve(P)), i(!1));
    });
  }, [
    m,
    d,
    y,
    g,
    C,
    e.schema
  ]);
  R(() => {
    L();
  }, [L]), R(() => {
    function V(W) {
      W.ctrlKey && W.key === "R" && L();
    }
    return s(V, "triggerIntrospection"), window.addEventListener("keydown", V), () => window.removeEventListener("keydown", V);
  });
  const b = G(() => !r || x ? [] : fn(r), [r, x]), w = G(
    () => ({
      fetchError: u,
      introspect: L,
      isFetching: a,
      schema: r,
      validationErrors: b
    }),
    [u, L, a, r, b]
  );
  return /* @__PURE__ */ o(Zt.Provider, { value: w, children: k });
}
s(Gt, "SchemaContextProvider");
const re = ce(Zt);
function jr({
  inputValueDeprecation: e,
  introspectionQueryName: t,
  schemaDescription: n
}) {
  return G(() => {
    const r = t || "IntrospectionQuery";
    let l = pn({
      inputValueDeprecation: e,
      schemaDescription: n
    });
    t && (l = l.replace("query IntrospectionQuery", `query ${r}`));
    const a = l.replace(
      "subscriptionType { name }",
      ""
    );
    return {
      introspectionQueryName: r,
      introspectionQuery: l,
      introspectionQuerySansSubscriptions: a
    };
  }, [e, t, n]);
}
s(jr, "useIntrospectionQuery");
function zr(e) {
  let t = null, n = !0;
  try {
    e && (t = JSON.parse(e));
  } catch {
    n = !1;
  }
  return { headers: t, isValidJSON: n };
}
s(zr, "parseHeaderString");
const Te = { name: "Docs" }, Qt = ae("ExplorerContext");
function jt(e) {
  const { schema: t, validationErrors: n } = re({
    nonNull: !0,
    caller: jt
  }), [r, l] = I([
    Te
  ]), a = N((h) => {
    l((f) => f.at(-1).def === h.def ? (
      // Avoid pushing duplicate items
      f
    ) : [...f, h]);
  }, []), i = N(() => {
    l(
      (h) => h.length > 1 ? h.slice(0, -1) : h
    );
  }, []), u = N(() => {
    l(
      (h) => h.length === 1 ? h : [Te]
    );
  }, []);
  R(() => {
    t == null || n.length > 0 ? u() : l((h) => {
      if (h.length === 1)
        return h;
      const f = [Te];
      let y = null;
      for (const d of h)
        if (d !== Te)
          if (d.def)
            if (Nt(d.def)) {
              const g = t.getType(d.def.name);
              if (g)
                f.push({
                  name: d.name,
                  def: g
                }), y = g;
              else
                break;
            } else {
              if (y === null)
                break;
              if (xe(y) || Fe(y)) {
                const g = y.getFields()[d.name];
                if (g)
                  f.push({
                    name: d.name,
                    def: g
                  });
                else
                  break;
              } else {
                if (gn(y) || kt(y) || Ee(y) || Cn(y))
                  break;
                {
                  const g = y;
                  if (g.args.find((C) => C.name === d.name))
                    f.push({
                      name: d.name,
                      def: g
                    });
                  else
                    break;
                }
              }
            }
          else
            y = null, f.push(d);
      return f;
    });
  }, [u, t, n]);
  const p = G(
    () => ({ explorerNavStack: r, push: a, pop: i, reset: u }),
    [r, a, i, u]
  );
  return /* @__PURE__ */ o(Qt.Provider, { value: p, children: e.children });
}
s(jt, "ExplorerContextProvider");
const ie = ce(Qt);
function De(e, t) {
  return Tt(e) ? /* @__PURE__ */ T(z, { children: [
    De(e.ofType, t),
    "!"
  ] }) : Mt(e) ? /* @__PURE__ */ T(z, { children: [
    "[",
    De(e.ofType, t),
    "]"
  ] }) : t(e);
}
s(De, "renderType");
function X(e) {
  const { push: t } = ie({ nonNull: !0, caller: X });
  return e.type ? De(e.type, (n) => /* @__PURE__ */ o(
    "a",
    {
      className: "graphiql-doc-explorer-type-name",
      onClick: (r) => {
        r.preventDefault(), t({ name: n.name, def: n });
      },
      href: "#",
      children: n.name
    }
  )) : null;
}
s(X, "TypeLink");
function Pe({ arg: e, showDefaultValue: t, inline: n }) {
  const r = /* @__PURE__ */ T("span", { children: [
    /* @__PURE__ */ o("span", { className: "graphiql-doc-explorer-argument-name", children: e.name }),
    ": ",
    /* @__PURE__ */ o(X, { type: e.type }),
    t !== !1 && /* @__PURE__ */ o($t, { field: e })
  ] });
  return n ? r : /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-argument", children: [
    r,
    e.description ? /* @__PURE__ */ o(te, { type: "description", children: e.description }) : null,
    e.deprecationReason ? /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-argument-deprecation", children: [
      /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-argument-deprecation-label", children: "Deprecated" }),
      /* @__PURE__ */ o(te, { type: "deprecation", children: e.deprecationReason })
    ] }) : null
  ] });
}
s(Pe, "Argument");
function zt(e) {
  return e.children ? /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-deprecation", children: [
    /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-deprecation-label", children: "Deprecated" }),
    /* @__PURE__ */ o(
      te,
      {
        type: "deprecation",
        onlyShowFirstChild: e.preview ?? !0,
        children: e.children
      }
    )
  ] }) : null;
}
s(zt, "DeprecationReason");
function Ur({ directive: e }) {
  return /* @__PURE__ */ T("span", { className: "graphiql-doc-explorer-directive", children: [
    "@",
    e.name.value
  ] });
}
s(Ur, "Directive");
function U(e) {
  const t = Kr[e.title];
  return /* @__PURE__ */ T("div", { children: [
    /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-section-title", children: [
      /* @__PURE__ */ o(t, {}),
      e.title
    ] }),
    /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-section-content", children: e.children })
  ] });
}
s(U, "ExplorerSection");
const Kr = {
  Arguments: gr,
  "Deprecated Arguments": vr,
  "Deprecated Enum Values": yr,
  "Deprecated Fields": br,
  Directives: wr,
  "Enum Values": Lr,
  Fields: Sr,
  Implements: kr,
  Implementations: ke,
  "Possible Types": ke,
  "Root Types": Hr,
  Type: ke,
  "All Schema Types": ke
};
function Jr(e) {
  return /* @__PURE__ */ T(z, { children: [
    e.field.description ? /* @__PURE__ */ o(te, { type: "description", children: e.field.description }) : null,
    /* @__PURE__ */ o(zt, { preview: !1, children: e.field.deprecationReason }),
    /* @__PURE__ */ o(U, { title: "Type", children: /* @__PURE__ */ o(X, { type: e.field.type }) }),
    /* @__PURE__ */ o(Yr, { field: e.field }),
    /* @__PURE__ */ o(Xr, { field: e.field })
  ] });
}
s(Jr, "FieldDocumentation");
function Yr({ field: e }) {
  const [t, n] = I(!1), r = N(() => {
    n(!0);
  }, []);
  if (!("args" in e))
    return null;
  const l = [], a = [];
  for (const i of e.args)
    i.deprecationReason ? a.push(i) : l.push(i);
  return /* @__PURE__ */ T(z, { children: [
    l.length > 0 ? /* @__PURE__ */ o(U, { title: "Arguments", children: l.map((i) => /* @__PURE__ */ o(Pe, { arg: i }, i.name)) }) : null,
    a.length > 0 ? t || l.length === 0 ? /* @__PURE__ */ o(U, { title: "Deprecated Arguments", children: a.map((i) => /* @__PURE__ */ o(Pe, { arg: i }, i.name)) }) : /* @__PURE__ */ o(Le, { type: "button", onClick: r, children: "Show Deprecated Arguments" }) : null
  ] });
}
s(Yr, "Arguments");
function Xr({ field: e }) {
  var n;
  const t = ((n = e.astNode) == null ? void 0 : n.directives) || [];
  return !t || t.length === 0 ? null : /* @__PURE__ */ o(U, { title: "Directives", children: t.map((r) => /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(Ur, { directive: r }) }, r.name.value)) });
}
s(Xr, "Directives");
function eo(e) {
  var i, u, p, h;
  const t = e.schema.getQueryType(), n = (u = (i = e.schema).getMutationType) == null ? void 0 : u.call(i), r = (h = (p = e.schema).getSubscriptionType) == null ? void 0 : h.call(p), l = e.schema.getTypeMap(), a = [
    t == null ? void 0 : t.name,
    n == null ? void 0 : n.name,
    r == null ? void 0 : r.name
  ];
  return /* @__PURE__ */ T(z, { children: [
    /* @__PURE__ */ o(te, { type: "description", children: e.schema.description || "A GraphQL schema provides a root type for each kind of operation." }),
    /* @__PURE__ */ T(U, { title: "Root Types", children: [
      t ? /* @__PURE__ */ T("div", { children: [
        /* @__PURE__ */ o("span", { className: "graphiql-doc-explorer-root-type", children: "query" }),
        ": ",
        /* @__PURE__ */ o(X, { type: t })
      ] }) : null,
      n && /* @__PURE__ */ T("div", { children: [
        /* @__PURE__ */ o("span", { className: "graphiql-doc-explorer-root-type", children: "mutation" }),
        ": ",
        /* @__PURE__ */ o(X, { type: n })
      ] }),
      r && /* @__PURE__ */ T("div", { children: [
        /* @__PURE__ */ o("span", { className: "graphiql-doc-explorer-root-type", children: "subscription" }),
        ": ",
        /* @__PURE__ */ o(X, { type: r })
      ] })
    ] }),
    /* @__PURE__ */ o(U, { title: "All Schema Types", children: l && /* @__PURE__ */ o("div", { children: Object.values(l).map((f) => a.includes(f.name) || f.name.startsWith("__") ? null : /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(X, { type: f }) }, f.name)) }) })
  ] });
}
s(eo, "SchemaDocumentation");
function fe(e, t) {
  let n;
  return function(...r) {
    n && window.clearTimeout(n), n = window.setTimeout(() => {
      n = null, t(...r);
    }, e);
  };
}
s(fe, "debounce");
function Ut() {
  const { explorerNavStack: e, push: t } = ie({
    nonNull: !0,
    caller: Ut
  }), n = B(null), r = tt(), [l, a] = I(""), [i, u] = I(r(l)), p = G(
    () => fe(200, (m) => {
      u(r(m));
    }),
    [r]
  );
  R(() => {
    p(l);
  }, [p, l]), R(() => {
    function m(C) {
      var x;
      C.metaKey && C.key === "k" && ((x = n.current) == null || x.focus());
    }
    return s(m, "handleKeyDown"), window.addEventListener("keydown", m), () => window.removeEventListener("keydown", m);
  }, []);
  const h = e.at(-1), f = N(
    (m) => {
      t(
        "field" in m ? { name: m.field.name, def: m.field } : { name: m.type.name, def: m.type }
      );
    },
    [t]
  ), y = B(!1), d = N((m) => {
    y.current = m.type === "focus";
  }, []);
  return e.length === 1 || xe(h.def) || Ee(h.def) || Fe(h.def) ? /* @__PURE__ */ T(
    he,
    {
      as: "div",
      className: "graphiql-doc-explorer-search",
      onChange: f,
      "data-state": y ? void 0 : "idle",
      "aria-label": `Search ${h.name}...`,
      children: [
        /* @__PURE__ */ T(
          "div",
          {
            className: "graphiql-doc-explorer-search-input",
            onClick: () => {
              var m;
              (m = n.current) == null || m.focus();
            },
            children: [
              /* @__PURE__ */ o(Tr, {}),
              /* @__PURE__ */ o(
                he.Input,
                {
                  autoComplete: "off",
                  onFocus: d,
                  onBlur: d,
                  onChange: (m) => a(m.target.value),
                  placeholder: "⌘ K",
                  ref: n,
                  value: l,
                  "data-cy": "doc-explorer-input"
                }
              )
            ]
          }
        ),
        y.current && /* @__PURE__ */ T(he.Options, { "data-cy": "doc-explorer-list", children: [
          i.within.length + i.types.length + i.fields.length === 0 ? /* @__PURE__ */ o("li", { className: "graphiql-doc-explorer-search-empty", children: "No results found" }) : i.within.map((m, C) => /* @__PURE__ */ o(
            he.Option,
            {
              value: m,
              "data-cy": "doc-explorer-option",
              children: /* @__PURE__ */ o(Ct, { field: m.field, argument: m.argument })
            },
            `within-${C}`
          )),
          i.within.length > 0 && i.types.length + i.fields.length > 0 ? /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-search-divider", children: "Other results" }) : null,
          i.types.map((m, C) => /* @__PURE__ */ o(
            he.Option,
            {
              value: m,
              "data-cy": "doc-explorer-option",
              children: /* @__PURE__ */ o(nt, { type: m.type })
            },
            `type-${C}`
          )),
          i.fields.map((m, C) => /* @__PURE__ */ T(
            he.Option,
            {
              value: m,
              "data-cy": "doc-explorer-option",
              children: [
                /* @__PURE__ */ o(nt, { type: m.type }),
                ".",
                /* @__PURE__ */ o(Ct, { field: m.field, argument: m.argument })
              ]
            },
            `field-${C}`
          ))
        ] })
      ]
    }
  ) : null;
}
s(Ut, "Search");
function tt(e) {
  const { explorerNavStack: t } = ie({
    nonNull: !0,
    caller: e || tt
  }), { schema: n } = re({
    nonNull: !0,
    caller: e || tt
  }), r = t.at(-1);
  return N(
    (l) => {
      const a = {
        within: [],
        types: [],
        fields: []
      };
      if (!n)
        return a;
      const i = r.def, u = n.getTypeMap();
      let p = Object.keys(u);
      i && (p = p.filter((h) => h !== i.name), p.unshift(i.name));
      for (const h of p) {
        if (a.within.length + a.types.length + a.fields.length >= 100)
          break;
        const f = u[h];
        if (i !== f && ze(h, l) && a.types.push({ type: f }), !xe(f) && !Ee(f) && !Fe(f))
          continue;
        const y = f.getFields();
        for (const d in y) {
          const g = y[d];
          let m;
          if (!ze(d, l))
            if ("args" in g) {
              if (m = g.args.filter(
                (C) => ze(C.name, l)
              ), m.length === 0)
                continue;
            } else
              continue;
          a[i === f ? "within" : "fields"].push(
            ...m ? m.map((C) => ({ type: f, field: g, argument: C })) : [{ type: f, field: g }]
          );
        }
      }
      return a;
    },
    [r.def, n]
  );
}
s(tt, "useSearchResults");
function ze(e, t) {
  try {
    const n = t.replaceAll(/[^_0-9A-Za-z]/g, (r) => "\\" + r);
    return e.search(new RegExp(n, "i")) !== -1;
  } catch {
    return e.toLowerCase().includes(t.toLowerCase());
  }
}
s(ze, "isMatch");
function nt(e) {
  return /* @__PURE__ */ o("span", { className: "graphiql-doc-explorer-search-type", children: e.type.name });
}
s(nt, "Type");
function Ct({ field: e, argument: t }) {
  return /* @__PURE__ */ T(z, { children: [
    /* @__PURE__ */ o("span", { className: "graphiql-doc-explorer-search-field", children: e.name }),
    t ? /* @__PURE__ */ T(z, { children: [
      "(",
      /* @__PURE__ */ o("span", { className: "graphiql-doc-explorer-search-argument", children: t.name }),
      ":",
      " ",
      De(t.type, (n) => /* @__PURE__ */ o(nt, { type: n })),
      ")"
    ] }) : null
  ] });
}
s(Ct, "Field$1");
function to(e) {
  const { push: t } = ie({ nonNull: !0 });
  return /* @__PURE__ */ o(
    "a",
    {
      className: "graphiql-doc-explorer-field-name",
      onClick: (n) => {
        n.preventDefault(), t({ name: e.field.name, def: e.field });
      },
      href: "#",
      children: e.field.name
    }
  );
}
s(to, "FieldLink");
function no(e) {
  return Nt(e.type) ? /* @__PURE__ */ T(z, { children: [
    e.type.description ? /* @__PURE__ */ o(te, { type: "description", children: e.type.description }) : null,
    /* @__PURE__ */ o(ro, { type: e.type }),
    /* @__PURE__ */ o(oo, { type: e.type }),
    /* @__PURE__ */ o(lo, { type: e.type }),
    /* @__PURE__ */ o(io, { type: e.type })
  ] }) : null;
}
s(no, "TypeDocumentation");
function ro({ type: e }) {
  return xe(e) && e.getInterfaces().length > 0 ? /* @__PURE__ */ o(U, { title: "Implements", children: e.getInterfaces().map((n) => /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(X, { type: n }) }, n.name)) }) : null;
}
s(ro, "ImplementsInterfaces");
function oo({ type: e }) {
  const [t, n] = I(!1), r = N(() => {
    n(!0);
  }, []);
  if (!xe(e) && !Ee(e) && !Fe(e))
    return null;
  const l = e.getFields(), a = [], i = [];
  for (const u of Object.keys(l).map((p) => l[p]))
    u.deprecationReason ? i.push(u) : a.push(u);
  return /* @__PURE__ */ T(z, { children: [
    a.length > 0 ? /* @__PURE__ */ o(U, { title: "Fields", children: a.map((u) => /* @__PURE__ */ o(vt, { field: u }, u.name)) }) : null,
    i.length > 0 ? t || a.length === 0 ? /* @__PURE__ */ o(U, { title: "Deprecated Fields", children: i.map((u) => /* @__PURE__ */ o(vt, { field: u }, u.name)) }) : /* @__PURE__ */ o(Le, { type: "button", onClick: r, children: "Show Deprecated Fields" }) : null
  ] });
}
s(oo, "Fields");
function vt({ field: e }) {
  const t = "args" in e ? e.args.filter((n) => !n.deprecationReason) : [];
  return /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-item", children: [
    /* @__PURE__ */ T("div", { children: [
      /* @__PURE__ */ o(to, { field: e }),
      t.length > 0 ? /* @__PURE__ */ T(z, { children: [
        "(",
        /* @__PURE__ */ o("span", { children: t.map(
          (n) => t.length === 1 ? /* @__PURE__ */ o(Pe, { arg: n, inline: !0 }, n.name) : /* @__PURE__ */ o(
            "div",
            {
              className: "graphiql-doc-explorer-argument-multiple",
              children: /* @__PURE__ */ o(Pe, { arg: n, inline: !0 })
            },
            n.name
          )
        ) }),
        ")"
      ] }) : null,
      ": ",
      /* @__PURE__ */ o(X, { type: e.type }),
      /* @__PURE__ */ o($t, { field: e })
    ] }),
    e.description ? /* @__PURE__ */ o(te, { type: "description", onlyShowFirstChild: !0, children: e.description }) : null,
    /* @__PURE__ */ o(zt, { children: e.deprecationReason })
  ] });
}
s(vt, "Field");
function lo({ type: e }) {
  const [t, n] = I(!1), r = N(() => {
    n(!0);
  }, []);
  if (!kt(e))
    return null;
  const l = [], a = [];
  for (const i of e.getValues())
    i.deprecationReason ? a.push(i) : l.push(i);
  return /* @__PURE__ */ T(z, { children: [
    l.length > 0 ? /* @__PURE__ */ o(U, { title: "Enum Values", children: l.map((i) => /* @__PURE__ */ o(yt, { value: i }, i.name)) }) : null,
    a.length > 0 ? t || l.length === 0 ? /* @__PURE__ */ o(U, { title: "Deprecated Enum Values", children: a.map((i) => /* @__PURE__ */ o(yt, { value: i }, i.name)) }) : /* @__PURE__ */ o(Le, { type: "button", onClick: r, children: "Show Deprecated Values" }) : null
  ] });
}
s(lo, "EnumValues");
function yt({ value: e }) {
  return /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-item", children: [
    /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-enum-value", children: e.name }),
    e.description ? /* @__PURE__ */ o(te, { type: "description", children: e.description }) : null,
    e.deprecationReason ? /* @__PURE__ */ o(te, { type: "deprecation", children: e.deprecationReason }) : null
  ] });
}
s(yt, "EnumValue");
function io({ type: e }) {
  const { schema: t } = re({ nonNull: !0 });
  return !t || !vn(e) ? null : /* @__PURE__ */ o(
    U,
    {
      title: Ee(e) ? "Implementations" : "Possible Types",
      children: t.getPossibleTypes(e).map((n) => /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(X, { type: n }) }, n.name))
    }
  );
}
s(io, "PossibleTypes");
function rt() {
  const { fetchError: e, isFetching: t, schema: n, validationErrors: r } = re(
    { nonNull: !0, caller: rt }
  ), { explorerNavStack: l, pop: a } = ie({
    nonNull: !0,
    caller: rt
  }), i = l.at(-1);
  let u = null;
  e ? u = /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-error", children: "Error fetching schema" }) : r.length > 0 ? u = /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-error", children: [
    "Schema is invalid: ",
    r[0].message
  ] }) : t ? u = /* @__PURE__ */ o(Dt, {}) : n ? l.length === 1 ? u = /* @__PURE__ */ o(eo, { schema: n }) : yn(i.def) ? u = /* @__PURE__ */ o(no, { type: i.def }) : i.def && (u = /* @__PURE__ */ o(Jr, { field: i.def })) : u = /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-error", children: "No GraphQL schema available" });
  let p;
  return l.length > 1 && (p = l.at(-2).name), /* @__PURE__ */ T(
    "section",
    {
      className: "graphiql-doc-explorer",
      "aria-label": "Documentation Explorer",
      children: [
        /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-header", children: [
          /* @__PURE__ */ T("div", { className: "graphiql-doc-explorer-header-content", children: [
            p && /* @__PURE__ */ T(
              "a",
              {
                href: "#",
                className: "graphiql-doc-explorer-back",
                onClick: (h) => {
                  h.preventDefault(), a();
                },
                "aria-label": `Go back to ${p}`,
                children: [
                  /* @__PURE__ */ o(Cr, {}),
                  p
                ]
              }
            ),
            /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-title", children: i.name })
          ] }),
          /* @__PURE__ */ o(Ut, {}, i.name)
        ] }),
        /* @__PURE__ */ o("div", { className: "graphiql-doc-explorer-content", children: u })
      ]
    }
  );
}
s(rt, "DocExplorer");
const ye = {
  title: "Documentation Explorer",
  icon: /* @__PURE__ */ s(function() {
    const t = at();
    return (t == null ? void 0 : t.visiblePlugin) === ye ? /* @__PURE__ */ o(xr, {}) : /* @__PURE__ */ o(Er, {});
  }, "Icon"),
  content: rt
}, bt = {
  title: "History",
  icon: Nr,
  content: Zr
}, Kt = ae("PluginContext");
function so(e) {
  const t = ue(), n = ie(), r = Be(), l = !!n, a = !!r, i = G(() => {
    const g = [], m = {};
    l && (g.push(ye), m[ye.title] = !0), a && (g.push(bt), m[bt.title] = !0);
    for (const C of e.plugins || []) {
      if (typeof C.title != "string" || !C.title)
        throw new Error("All GraphiQL plugins must have a unique title");
      if (m[C.title])
        throw new Error(
          `All GraphiQL plugins must have a unique title, found two plugins with the title '${C.title}'`
        );
      g.push(C), m[C.title] = !0;
    }
    return g;
  }, [l, a, e.plugins]), [u, p] = I(() => {
    const g = t == null ? void 0 : t.get(wt), m = i.find(
      (C) => C.title === g
    );
    return m || (g && (t == null || t.set(wt, "")), e.visiblePlugin && i.find(
      (C) => (typeof e.visiblePlugin == "string" ? C.title : C) === e.visiblePlugin
    ) || null);
  }), { onTogglePluginVisibility: h, children: f } = e, y = N(
    (g) => {
      const m = g && i.find(
        (C) => (typeof g == "string" ? C.title : C) === g
      ) || null;
      p((C) => m === C ? C : (h == null || h(m), m));
    },
    [h, i]
  );
  R(() => {
    e.visiblePlugin && y(e.visiblePlugin);
  }, [i, e.visiblePlugin, y]);
  const d = G(
    () => ({ plugins: i, setVisiblePlugin: y, visiblePlugin: u }),
    [i, y, u]
  );
  return /* @__PURE__ */ o(Kt.Provider, { value: d, children: f });
}
s(so, "PluginContextProvider");
const at = ce(Kt), wt = "visiblePlugin";
function ao(e, t, n, r, l, a) {
  Ne([], { useCommonAddons: !1 }).then((u) => {
    let p, h, f, y, d, g, m, C, x;
    u.on(
      t,
      "select",
      // @ts-expect-error
      (k, L) => {
        if (!p) {
          const b = L.parentNode;
          p = document.createElement("div"), p.className = "CodeMirror-hint-information", b.append(p);
          const w = document.createElement("header");
          w.className = "CodeMirror-hint-information-header", p.append(w), h = document.createElement("span"), h.className = "CodeMirror-hint-information-field-name", w.append(h), f = document.createElement("span"), f.className = "CodeMirror-hint-information-type-name-pill", w.append(f), y = document.createElement("span"), f.append(y), d = document.createElement("a"), d.className = "CodeMirror-hint-information-type-name", d.href = "javascript:void 0", d.addEventListener("click", i), f.append(d), g = document.createElement("span"), f.append(g), m = document.createElement("div"), m.className = "CodeMirror-hint-information-description", p.append(m), C = document.createElement("div"), C.className = "CodeMirror-hint-information-deprecation", p.append(C);
          const V = document.createElement("span");
          V.className = "CodeMirror-hint-information-deprecation-label", V.textContent = "Deprecated", C.append(V), x = document.createElement("div"), x.className = "CodeMirror-hint-information-deprecation-reason", C.append(x);
          const W = parseInt(
            window.getComputedStyle(p).paddingBottom.replace(/px$/, ""),
            10
          ) || 0, $ = parseInt(
            window.getComputedStyle(p).maxHeight.replace(/px$/, ""),
            10
          ) || 0, P = /* @__PURE__ */ s(() => {
            p && (p.style.paddingTop = b.scrollTop + W + "px", p.style.maxHeight = b.scrollTop + $ + "px");
          }, "handleScroll");
          b.addEventListener("scroll", P);
          let O;
          b.addEventListener(
            "DOMNodeRemoved",
            O = /* @__PURE__ */ s((_) => {
              _.target === b && (b.removeEventListener("scroll", P), b.removeEventListener("DOMNodeRemoved", O), p && p.removeEventListener(
                "click",
                i
              ), p = null, h = null, f = null, y = null, d = null, g = null, m = null, C = null, x = null, O = null);
            }, "onRemoveFn")
          );
        }
        if (h && (h.textContent = k.text), f && y && d && g)
          if (k.type) {
            f.style.display = "inline";
            const b = /* @__PURE__ */ s((w) => {
              Tt(w) ? (g.textContent = "!" + g.textContent, b(w.ofType)) : Mt(w) ? (y.textContent += "[", g.textContent = "]" + g.textContent, b(w.ofType)) : d.textContent = w.name;
            }, "renderType");
            y.textContent = "", g.textContent = "", b(k.type);
          } else
            y.textContent = "", d.textContent = "", g.textContent = "", f.style.display = "none";
        m && (k.description ? (m.style.display = "block", m.innerHTML = qe.render(k.description)) : (m.style.display = "none", m.innerHTML = "")), C && x && (k.deprecationReason ? (C.style.display = "block", x.innerHTML = qe.render(
          k.deprecationReason
        )) : (C.style.display = "none", x.innerHTML = ""));
      }
    );
  });
  function i(u) {
    if (!n || !r || !l || !(u.currentTarget instanceof HTMLElement))
      return;
    const p = u.currentTarget.textContent || "", h = n.getType(p);
    h && (l.setVisiblePlugin(ye), r.push({ name: h.name, def: h }), a == null || a(h));
  }
  s(i, "onClickHintInformation");
}
s(ao, "onHasCompletion");
function Me(e, t) {
  R(() => {
    e && typeof t == "string" && t !== e.getValue() && e.setValue(t);
  }, [e, t]);
}
s(Me, "useSynchronizeValue");
function Ge(e, t, n) {
  R(() => {
    e && e.setOption(t, n);
  }, [e, t, n]);
}
s(Ge, "useSynchronizeOption");
function Jt(e, t, n, r, l) {
  const { updateActiveTabValues: a } = j({ nonNull: !0, caller: l }), i = ue();
  R(() => {
    if (!e)
      return;
    const u = fe(500, (f) => {
      !i || n === null || i.set(n, f);
    }), p = fe(100, (f) => {
      a({ [r]: f });
    }), h = /* @__PURE__ */ s((f, y) => {
      if (!y)
        return;
      const d = f.getValue();
      u(d), p(d), t == null || t(d);
    }, "handleChange");
    return e.on("change", h), () => e.off("change", h);
  }, [
    t,
    e,
    i,
    n,
    r,
    a
  ]);
}
s(Jt, "useChangeHandler");
function Yt(e, t, n) {
  const { schema: r } = re({ nonNull: !0, caller: n }), l = ie(), a = at();
  R(() => {
    if (!e)
      return;
    const i = /* @__PURE__ */ s((u, p) => {
      ao(u, p, r, l, a, (h) => {
        t == null || t({ kind: "Type", type: h, schema: r || void 0 });
      });
    }, "handleCompletion");
    return e.on(
      // @ts-expect-error @TODO additional args for hasCompletion event
      "hasCompletion",
      i
    ), () => e.off(
      // @ts-expect-error @TODO additional args for hasCompletion event
      "hasCompletion",
      i
    );
  }, [t, e, l, a, r]);
}
s(Yt, "useCompletion");
function ee(e, t, n) {
  R(() => {
    if (e) {
      for (const r of t)
        e.removeKeyMap(r);
      if (n) {
        const r = {};
        for (const l of t)
          r[l] = () => n();
        e.addKeyMap(r);
      }
    }
  }, [e, t, n]);
}
s(ee, "useKeyMap");
function Xt({ caller: e, onCopyQuery: t } = {}) {
  const { queryEditor: n } = j({
    nonNull: !0,
    caller: e || Xt
  });
  return N(() => {
    if (!n)
      return;
    const r = n.getValue();
    Vn(r), t == null || t(r);
  }, [n, t]);
}
s(Xt, "useCopyQuery");
function be({ caller: e } = {}) {
  const { queryEditor: t } = j({
    nonNull: !0,
    caller: e || be
  }), { schema: n } = re({ nonNull: !0, caller: be });
  return N(() => {
    const r = t == null ? void 0 : t.documentAST, l = t == null ? void 0 : t.getValue();
    !r || !l || t.setValue(Oe(Ln(r, n)));
  }, [t, n]);
}
s(be, "useMergeQuery");
function Qe({ caller: e } = {}) {
  const { queryEditor: t, headerEditor: n, variableEditor: r } = j({
    nonNull: !0,
    caller: e || Qe
  });
  return N(() => {
    if (r) {
      const l = r.getValue();
      try {
        const a = JSON.stringify(
          JSON.parse(l),
          null,
          2
        );
        a !== l && r.setValue(a);
      } catch {
      }
    }
    if (n) {
      const l = n.getValue();
      try {
        const a = JSON.stringify(
          JSON.parse(l),
          null,
          2
        );
        a !== l && n.setValue(a);
      } catch {
      }
    }
    if (t) {
      const l = t.getValue(), a = Oe(Vt(l));
      a !== l && t.setValue(a);
    }
  }, [t, r, n]);
}
s(Qe, "usePrettifyEditors");
function ot({
  getDefaultFieldNames: e,
  caller: t
} = {}) {
  const { schema: n } = re({
    nonNull: !0,
    caller: t || ot
  }), { queryEditor: r } = j({
    nonNull: !0,
    caller: t || ot
  });
  return N(() => {
    if (!r)
      return;
    const l = r.getValue(), { insertions: a, result: i } = Sn(
      n,
      l,
      e
    );
    return a && a.length > 0 && r.operation(() => {
      const u = r.getCursor(), p = r.indexFromPos(u);
      r.setValue(i || "");
      let h = 0;
      const f = a.map(
        ({ index: d, string: g }) => r.markText(
          r.posFromIndex(d + h),
          r.posFromIndex(d + (h += g.length)),
          {
            className: "auto-inserted-leaf",
            clearOnEnter: !0,
            title: "Automatically added leaf fields"
          }
        )
      );
      setTimeout(() => {
        for (const d of f)
          d.clear();
      }, 7e3);
      let y = p;
      for (const { index: d, string: g } of a)
        d < p && (y += g.length);
      r.setCursor(r.posFromIndex(y));
    }), i;
  }, [e, r, n]);
}
s(ot, "useAutoCompleteLeafs");
const ct = /* @__PURE__ */ s((e) => {
  const n = j({
    nonNull: !0
  })[`${e}Editor`];
  let r = "";
  const l = (n == null ? void 0 : n.getValue()) ?? !1;
  l && l.length > 0 && (r = l);
  const a = N(
    (i) => n == null ? void 0 : n.setValue(i),
    [n]
  );
  return G(
    () => [r, a],
    [r, a]
  );
}, "useEditorState"), il = /* @__PURE__ */ s(() => ct("query"), "useOperationsEditorState"), sl = /* @__PURE__ */ s(() => ct("variable"), "useVariablesEditorState"), al = /* @__PURE__ */ s(() => ct("header"), "useHeadersEditorState");
function cl([
  e,
  t
]) {
  const n = B({
    /** The last thing that we sent upstream; we're expecting this back */
    pending: null,
    /** The last thing we received from upstream */
    last: e
  }), [r, l] = I(e);
  R(() => {
    n.current.last === e || (n.current.last = e, n.current.pending === null ? l(e) : n.current.pending === e ? (n.current.pending = null, e !== r && (n.current.pending = r, t(r))) : (n.current.pending = null, l(e)));
  }, [e, r, t]);
  const a = N(
    (i) => {
      l(i), n.current.pending === null && n.current.last !== i && (n.current.pending = i, t(i));
    },
    [t]
  );
  return G(() => [r, a], [r, a]);
}
s(cl, "useOptimisticState");
function Ce({
  editorTheme: e = _e,
  keyMap: t = $e,
  onEdit: n,
  readOnly: r = !1
} = {}, l) {
  const {
    initialHeaders: a,
    headerEditor: i,
    setHeaderEditor: u,
    shouldPersistHeaders: p
  } = j({
    nonNull: !0,
    caller: l || Ce
  }), h = We(), f = be({ caller: l || Ce }), y = Qe({ caller: l || Ce }), d = B(null);
  return R(() => {
    let g = !0;
    return Ne([
      // @ts-expect-error
      import("./javascript.es.js").then((m) => m.j)
    ]).then((m) => {
      if (!g)
        return;
      const C = d.current;
      if (!C)
        return;
      const x = m(C, {
        value: a,
        lineNumbers: !0,
        tabSize: 2,
        mode: { name: "javascript", json: !0 },
        theme: e,
        autoCloseBrackets: !0,
        matchBrackets: !0,
        showCursorWhenSelecting: !0,
        readOnly: r ? "nocursor" : !1,
        foldGutter: !0,
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        extraKeys: Ze
      });
      x.addKeyMap({
        "Cmd-Space"() {
          x.showHint({ completeSingle: !1, container: C });
        },
        "Ctrl-Space"() {
          x.showHint({ completeSingle: !1, container: C });
        },
        "Alt-Space"() {
          x.showHint({ completeSingle: !1, container: C });
        },
        "Shift-Space"() {
          x.showHint({ completeSingle: !1, container: C });
        }
      }), x.on("keyup", (k, L) => {
        const { code: b, key: w, shiftKey: V } = L, W = b.startsWith("Key"), $ = !V && b.startsWith("Digit");
        (W || $ || w === "_" || w === '"') && k.execCommand("autocomplete");
      }), u(x);
    }), () => {
      g = !1;
    };
  }, [e, a, r, u]), Ge(i, "keyMap", t), Jt(
    i,
    n,
    p ? Ae : null,
    "headers",
    Ce
  ), ee(i, ["Cmd-Enter", "Ctrl-Enter"], h == null ? void 0 : h.run), ee(i, ["Shift-Ctrl-P"], y), ee(i, ["Shift-Ctrl-M"], f), d;
}
s(Ce, "useHeaderEditor");
const Ae = "headers", co = Array.from({ length: 11 }, (e, t) => String.fromCharCode(8192 + t)).concat(["\u2028", "\u2029", " ", " "]), uo = new RegExp("[" + co.join("") + "]", "g");
function ho(e) {
  return e.replace(uo, " ");
}
s(ho, "normalizeWhitespace");
function se({
  editorTheme: e = _e,
  keyMap: t = $e,
  onClickReference: n,
  onCopyQuery: r,
  onEdit: l,
  readOnly: a = !1
} = {}, i) {
  const { schema: u } = re({
    nonNull: !0,
    caller: i || se
  }), {
    externalFragments: p,
    initialQuery: h,
    queryEditor: f,
    setOperationName: y,
    setQueryEditor: d,
    validationRules: g,
    variableEditor: m,
    updateActiveTabValues: C
  } = j({
    nonNull: !0,
    caller: i || se
  }), x = We(), k = ue(), L = ie(), b = at(), w = Xt({ caller: i || se, onCopyQuery: r }), V = be({ caller: i || se }), W = Qe({ caller: i || se }), $ = B(null), P = B(), O = B(() => {
  });
  R(() => {
    O.current = (A) => {
      if (!(!L || !b)) {
        switch (b.setVisiblePlugin(ye), A.kind) {
          case "Type": {
            L.push({ name: A.type.name, def: A.type });
            break;
          }
          case "Field": {
            L.push({ name: A.field.name, def: A.field });
            break;
          }
          case "Argument": {
            A.field && L.push({ name: A.field.name, def: A.field });
            break;
          }
          case "EnumValue": {
            A.type && L.push({ name: A.type.name, def: A.type });
            break;
          }
        }
        n == null || n(A);
      }
    };
  }, [L, n, b]), R(() => {
    let A = !0;
    return Ne([
      import("./comment.es.js").then((M) => M.c),
      import("./search.es.js").then((M) => M.s),
      import("./hint.es.js"),
      import("./lint.es2.js"),
      import("./info.es.js"),
      import("./jump.es.js"),
      import("./mode.es.js")
    ]).then((M) => {
      if (!A)
        return;
      P.current = M;
      const H = $.current;
      if (!H)
        return;
      const E = M(H, {
        value: h,
        lineNumbers: !0,
        tabSize: 2,
        foldGutter: !0,
        mode: "graphql",
        theme: e,
        autoCloseBrackets: !0,
        matchBrackets: !0,
        showCursorWhenSelecting: !0,
        readOnly: a ? "nocursor" : !1,
        lint: {
          // @ts-expect-error
          schema: void 0,
          validationRules: null,
          // linting accepts string or FragmentDefinitionNode[]
          externalFragments: void 0
        },
        hintOptions: {
          // @ts-expect-error
          schema: void 0,
          closeOnUnfocus: !1,
          completeSingle: !1,
          container: H,
          externalFragments: void 0,
          autocompleteOptions: {
            // for the query editor, restrict to executable type definitions
            mode: Tn.EXECUTABLE
          }
        },
        info: {
          schema: void 0,
          renderDescription: (v) => qe.render(v),
          onClick(v) {
            O.current(v);
          }
        },
        jump: {
          schema: void 0,
          onClick(v) {
            O.current(v);
          }
        },
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        extraKeys: {
          ...Ze,
          "Cmd-S"() {
          },
          "Ctrl-S"() {
          }
        }
      });
      E.addKeyMap({
        "Cmd-Space"() {
          E.showHint({ completeSingle: !0, container: H });
        },
        "Ctrl-Space"() {
          E.showHint({ completeSingle: !0, container: H });
        },
        "Alt-Space"() {
          E.showHint({ completeSingle: !0, container: H });
        },
        "Shift-Space"() {
          E.showHint({ completeSingle: !0, container: H });
        },
        "Shift-Alt-Space"() {
          E.showHint({ completeSingle: !0, container: H });
        }
      }), E.on("keyup", (v, S) => {
        go.test(S.key) && v.execCommand("autocomplete");
      });
      let Z = !1;
      E.on("startCompletion", () => {
        Z = !0;
      }), E.on("endCompletion", () => {
        Z = !1;
      }), E.on("keydown", (v, S) => {
        S.key === "Escape" && Z && S.stopPropagation();
      }), E.on("beforeChange", (v, S) => {
        var q;
        if (S.origin === "paste") {
          const Y = S.text.map(ho);
          (q = S.update) == null || q.call(S, S.from, S.to, Y);
        }
      }), E.documentAST = null, E.operationName = null, E.operations = null, E.variableToType = null, d(E);
    }), () => {
      A = !1;
    };
  }, [e, h, a, d]), Ge(f, "keyMap", t), R(() => {
    if (!f)
      return;
    function A(H) {
      var v;
      const E = Mn(
        u,
        H.getValue()
      ), Z = Nn(
        H.operations ?? void 0,
        H.operationName ?? void 0,
        E == null ? void 0 : E.operations
      );
      return H.documentAST = (E == null ? void 0 : E.documentAST) ?? null, H.operationName = Z ?? null, H.operations = (E == null ? void 0 : E.operations) ?? null, m && (m.state.lint.linterOptions.variableToType = E == null ? void 0 : E.variableToType, m.options.lint.variableToType = E == null ? void 0 : E.variableToType, m.options.hintOptions.variableToType = E == null ? void 0 : E.variableToType, (v = P.current) == null || v.signal(m, "change", m)), E ? { ...E, operationName: Z } : null;
    }
    s(A, "getAndUpdateOperationFacts");
    const M = fe(
      100,
      (H) => {
        const E = H.getValue();
        k == null || k.set(en, E);
        const Z = H.operationName, v = A(H);
        (v == null ? void 0 : v.operationName) !== void 0 && (k == null || k.set(
          Co,
          v.operationName
        )), l == null || l(E, v == null ? void 0 : v.documentAST), v != null && v.operationName && Z !== v.operationName && y(v.operationName), C({
          query: E,
          operationName: (v == null ? void 0 : v.operationName) ?? null
        });
      }
    );
    return A(f), f.on("change", M), () => f.off("change", M);
  }, [
    l,
    f,
    u,
    y,
    k,
    m,
    C
  ]), mo(f, u ?? null, P), fo(
    f,
    g ?? null,
    P
  ), po(
    f,
    p,
    P
  ), Yt(f, n || null, se);
  const _ = x == null ? void 0 : x.run, F = N(() => {
    var H;
    if (!_ || !f || !f.operations || !f.hasFocus()) {
      _ == null || _();
      return;
    }
    const A = f.indexFromPos(f.getCursor());
    let M;
    for (const E of f.operations)
      E.loc && E.loc.start <= A && E.loc.end >= A && (M = (H = E.name) == null ? void 0 : H.value);
    M && M !== f.operationName && y(M), _();
  }, [f, _, y]);
  return ee(f, ["Cmd-Enter", "Ctrl-Enter"], F), ee(f, ["Shift-Ctrl-C"], w), ee(
    f,
    [
      "Shift-Ctrl-P",
      // Shift-Ctrl-P is hard coded in Firefox for private browsing so adding an alternative to prettify
      "Shift-Ctrl-F"
    ],
    W
  ), ee(f, ["Shift-Ctrl-M"], V), $;
}
s(se, "useQueryEditor");
function mo(e, t, n) {
  R(() => {
    if (!e)
      return;
    const r = e.options.lint.schema !== t;
    e.state.lint.linterOptions.schema = t, e.options.lint.schema = t, e.options.hintOptions.schema = t, e.options.info.schema = t, e.options.jump.schema = t, r && n.current && n.current.signal(e, "change", e);
  }, [e, t, n]);
}
s(mo, "useSynchronizeSchema");
function fo(e, t, n) {
  R(() => {
    if (!e)
      return;
    const r = e.options.lint.validationRules !== t;
    e.state.lint.linterOptions.validationRules = t, e.options.lint.validationRules = t, r && n.current && n.current.signal(e, "change", e);
  }, [e, t, n]);
}
s(fo, "useSynchronizeValidationRules");
function po(e, t, n) {
  const r = G(
    () => [...t.values()],
    [t]
  );
  R(() => {
    if (!e)
      return;
    const l = e.options.lint.externalFragments !== r;
    e.state.lint.linterOptions.externalFragments = r, e.options.lint.externalFragments = r, e.options.hintOptions.externalFragments = r, l && n.current && n.current.signal(e, "change", e);
  }, [e, r, n]);
}
s(po, "useSynchronizeExternalFragments");
const go = /^[a-zA-Z0-9_@(]$/, en = "query", Co = "operationName";
function vo({
  defaultQuery: e,
  defaultHeaders: t,
  headers: n,
  defaultTabs: r,
  query: l,
  variables: a,
  storage: i,
  shouldPersistHeaders: u
}) {
  const p = i == null ? void 0 : i.get(we);
  try {
    if (!p)
      throw new Error("Storage for tabs is empty");
    const h = JSON.parse(p), f = u ? n : void 0;
    if (yo(h)) {
      const y = Ie({
        query: l,
        variables: a,
        headers: f
      });
      let d = -1;
      for (let g = 0; g < h.tabs.length; g++) {
        const m = h.tabs[g];
        m.hash = Ie({
          query: m.query,
          variables: m.variables,
          headers: m.headers
        }), m.hash === y && (d = g);
      }
      if (d >= 0)
        h.activeTabIndex = d;
      else {
        const g = l ? ut(l) : null;
        h.tabs.push({
          id: on(),
          hash: y,
          title: g || dt,
          query: l,
          variables: a,
          headers: n,
          operationName: g,
          response: null
        }), h.activeTabIndex = h.tabs.length - 1;
      }
      return h;
    }
    throw new Error("Storage for tabs is invalid");
  } catch {
    return {
      activeTabIndex: 0,
      tabs: (r || [
        {
          query: l ?? e,
          variables: a,
          headers: n ?? t
        }
      ]).map(nn)
    };
  }
}
s(vo, "getDefaultTabState");
function yo(e) {
  return e && typeof e == "object" && !Array.isArray(e) && wo(e, "activeTabIndex") && "tabs" in e && Array.isArray(e.tabs) && e.tabs.every(bo);
}
s(yo, "isTabsState");
function bo(e) {
  return e && typeof e == "object" && !Array.isArray(e) && xt(e, "id") && xt(e, "title") && pe(e, "query") && pe(e, "variables") && pe(e, "headers") && pe(e, "operationName") && pe(e, "response");
}
s(bo, "isTabState");
function wo(e, t) {
  return t in e && typeof e[t] == "number";
}
s(wo, "hasNumberKey");
function xt(e, t) {
  return t in e && typeof e[t] == "string";
}
s(xt, "hasStringKey");
function pe(e, t) {
  return t in e && (typeof e[t] == "string" || e[t] === null);
}
s(pe, "hasStringOrNullKey");
function xo({
  queryEditor: e,
  variableEditor: t,
  headerEditor: n,
  responseEditor: r
}) {
  return N(
    (l) => {
      const a = (e == null ? void 0 : e.getValue()) ?? null, i = (t == null ? void 0 : t.getValue()) ?? null, u = (n == null ? void 0 : n.getValue()) ?? null, p = (e == null ? void 0 : e.operationName) ?? null, h = (r == null ? void 0 : r.getValue()) ?? null;
      return rn(l, {
        query: a,
        variables: i,
        headers: u,
        response: h,
        operationName: p
      });
    },
    [e, t, n, r]
  );
}
s(xo, "useSynchronizeActiveTabValues");
function tn(e, t = !1) {
  return JSON.stringify(
    e,
    (n, r) => n === "hash" || n === "response" || !t && n === "headers" ? null : r
  );
}
s(tn, "serializeTabState");
function Eo({
  storage: e,
  shouldPersistHeaders: t
}) {
  const n = G(
    () => fe(500, (r) => {
      e == null || e.set(we, r);
    }),
    [e]
  );
  return N(
    (r) => {
      n(tn(r, t));
    },
    [t, n]
  );
}
s(Eo, "useStoreTabs");
function Lo({
  queryEditor: e,
  variableEditor: t,
  headerEditor: n,
  responseEditor: r
}) {
  return N(
    ({
      query: l,
      variables: a,
      headers: i,
      response: u
    }) => {
      e == null || e.setValue(l ?? ""), t == null || t.setValue(a ?? ""), n == null || n.setValue(i ?? ""), r == null || r.setValue(u ?? "");
    },
    [n, e, r, t]
  );
}
s(Lo, "useSetEditorValues");
function nn({
  query: e = null,
  variables: t = null,
  headers: n = null
} = {}) {
  return {
    id: on(),
    hash: Ie({ query: e, variables: t, headers: n }),
    title: e && ut(e) || dt,
    query: e,
    variables: t,
    headers: n,
    operationName: null,
    response: null
  };
}
s(nn, "createTab");
function rn(e, t) {
  return {
    ...e,
    tabs: e.tabs.map((n, r) => {
      if (r !== e.activeTabIndex)
        return n;
      const l = { ...n, ...t };
      return {
        ...l,
        hash: Ie(l),
        title: l.operationName || (l.query ? ut(l.query) : void 0) || dt
      };
    })
  };
}
s(rn, "setPropertiesInActiveTab");
function on() {
  const e = /* @__PURE__ */ s(() => Math.floor((1 + Math.random()) * 65536).toString(16).slice(1), "s4");
  return `${e()}${e()}-${e()}-${e()}-${e()}-${e()}${e()}${e()}`;
}
s(on, "guid");
function Ie(e) {
  return [e.query ?? "", e.variables ?? "", e.headers ?? ""].join("|");
}
s(Ie, "hashFromTabContents");
function ut(e) {
  const n = /^(?!#).*(query|subscription|mutation)\s+([a-zA-Z0-9_]+)/m.exec(e);
  return (n == null ? void 0 : n[2]) ?? null;
}
s(ut, "fuzzyExtractOperationName");
function So(e) {
  const t = e == null ? void 0 : e.get(we);
  if (t) {
    const n = JSON.parse(t);
    e == null || e.set(
      we,
      JSON.stringify(
        n,
        (r, l) => r === "headers" ? null : l
      )
    );
  }
}
s(So, "clearHeadersFromTabs");
const dt = "<untitled>", we = "tabState";
function me({
  editorTheme: e = _e,
  keyMap: t = $e,
  onClickReference: n,
  onEdit: r,
  readOnly: l = !1
} = {}, a) {
  const { initialVariables: i, variableEditor: u, setVariableEditor: p } = j({
    nonNull: !0,
    caller: a || me
  }), h = We(), f = be({ caller: a || me }), y = Qe({ caller: a || me }), d = B(null), g = B();
  return R(() => {
    let m = !0;
    return Ne([
      import("./hint.es2.js"),
      import("./lint.es3.js"),
      import("./mode.es2.js")
    ]).then((C) => {
      if (!m)
        return;
      g.current = C;
      const x = d.current;
      if (!x)
        return;
      const k = C(x, {
        value: i,
        lineNumbers: !0,
        tabSize: 2,
        mode: "graphql-variables",
        theme: e,
        autoCloseBrackets: !0,
        matchBrackets: !0,
        showCursorWhenSelecting: !0,
        readOnly: l ? "nocursor" : !1,
        foldGutter: !0,
        lint: {
          // @ts-expect-error
          variableToType: void 0
        },
        hintOptions: {
          closeOnUnfocus: !1,
          completeSingle: !1,
          container: x,
          // @ts-expect-error
          variableToType: void 0
        },
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        extraKeys: Ze
      });
      k.addKeyMap({
        "Cmd-Space"() {
          k.showHint({ completeSingle: !1, container: x });
        },
        "Ctrl-Space"() {
          k.showHint({ completeSingle: !1, container: x });
        },
        "Alt-Space"() {
          k.showHint({ completeSingle: !1, container: x });
        },
        "Shift-Space"() {
          k.showHint({ completeSingle: !1, container: x });
        }
      }), k.on("keyup", (L, b) => {
        const { code: w, key: V, shiftKey: W } = b, $ = w.startsWith("Key"), P = !W && w.startsWith("Digit");
        ($ || P || V === "_" || V === '"') && L.execCommand("autocomplete");
      }), p(k);
    }), () => {
      m = !1;
    };
  }, [e, i, l, p]), Ge(u, "keyMap", t), Jt(
    u,
    r,
    ln,
    "variables",
    me
  ), Yt(u, n || null, me), ee(u, ["Cmd-Enter", "Ctrl-Enter"], h == null ? void 0 : h.run), ee(u, ["Shift-Ctrl-P"], y), ee(u, ["Shift-Ctrl-M"], f), d;
}
s(me, "useVariableEditor");
const ln = "variables", sn = ae("EditorContext");
function No(e) {
  const t = ue(), [n, r] = I(
    null
  ), [l, a] = I(null), [i, u] = I(
    null
  ), [p, h] = I(
    null
  ), [f, y] = I(
    () => {
      const v = (t == null ? void 0 : t.get(Ue)) !== null;
      return e.shouldPersistHeaders !== !1 && v ? (t == null ? void 0 : t.get(Ue)) === "true" : !!e.shouldPersistHeaders;
    }
  );
  Me(n, e.headers), Me(l, e.query), Me(i, e.response), Me(p, e.variables);
  const d = Eo({
    storage: t,
    shouldPersistHeaders: f
  }), [g] = I(() => {
    const v = e.query ?? (t == null ? void 0 : t.get(en)) ?? null, S = e.variables ?? (t == null ? void 0 : t.get(ln)) ?? null, q = e.headers ?? (t == null ? void 0 : t.get(Ae)) ?? null, Y = e.response ?? "", de = vo({
      query: v,
      variables: S,
      headers: q,
      defaultTabs: e.defaultTabs,
      defaultQuery: e.defaultQuery || ko,
      defaultHeaders: e.defaultHeaders,
      storage: t,
      shouldPersistHeaders: f
    });
    return d(de), {
      query: v ?? (de.activeTabIndex === 0 ? de.tabs[0].query : null) ?? "",
      variables: S ?? "",
      headers: q ?? e.defaultHeaders ?? "",
      response: Y,
      tabState: de
    };
  }), [m, C] = I(g.tabState), x = N(
    (v) => {
      if (v) {
        t == null || t.set(Ae, (n == null ? void 0 : n.getValue()) ?? "");
        const S = tn(m, !0);
        t == null || t.set(we, S);
      } else
        t == null || t.set(Ae, ""), So(t);
      y(v), t == null || t.set(Ue, v.toString());
    },
    [t, m, n]
  ), k = B();
  R(() => {
    const v = !!e.shouldPersistHeaders;
    (k == null ? void 0 : k.current) !== v && (x(v), k.current = v);
  }, [e.shouldPersistHeaders, x]);
  const L = xo({
    queryEditor: l,
    variableEditor: p,
    headerEditor: n,
    responseEditor: i
  }), b = Lo({
    queryEditor: l,
    variableEditor: p,
    headerEditor: n,
    responseEditor: i
  }), { onTabChange: w, defaultHeaders: V, children: W } = e, $ = N(() => {
    C((v) => {
      const S = L(v), q = {
        tabs: [...S.tabs, nn({ headers: V })],
        activeTabIndex: S.tabs.length
      };
      return d(q), b(q.tabs[q.activeTabIndex]), w == null || w(q), q;
    });
  }, [
    V,
    w,
    b,
    d,
    L
  ]), P = N(
    (v) => {
      C((S) => {
        const q = {
          ...S,
          activeTabIndex: v
        };
        return d(q), b(q.tabs[q.activeTabIndex]), w == null || w(q), q;
      });
    },
    [w, b, d]
  ), O = N(
    (v) => {
      C((S) => {
        const q = S.tabs[S.activeTabIndex], Y = {
          tabs: v,
          activeTabIndex: v.indexOf(q)
        };
        return d(Y), b(Y.tabs[Y.activeTabIndex]), w == null || w(Y), Y;
      });
    },
    [w, b, d]
  ), _ = N(
    (v) => {
      C((S) => {
        const q = {
          tabs: S.tabs.filter((Y, de) => v !== de),
          activeTabIndex: Math.max(S.activeTabIndex - 1, 0)
        };
        return d(q), b(q.tabs[q.activeTabIndex]), w == null || w(q), q;
      });
    },
    [w, b, d]
  ), F = N(
    (v) => {
      C((S) => {
        const q = rn(S, v);
        return d(q), w == null || w(q), q;
      });
    },
    [w, d]
  ), { onEditOperationName: A } = e, M = N(
    (v) => {
      l && (l.operationName = v, F({ operationName: v }), A == null || A(v));
    },
    [A, l, F]
  ), H = G(() => {
    const v = /* @__PURE__ */ new Map();
    if (Array.isArray(e.externalFragments))
      for (const S of e.externalFragments)
        v.set(S.name.value, S);
    else if (typeof e.externalFragments == "string")
      bn(Vt(e.externalFragments, {}), {
        FragmentDefinition(S) {
          v.set(S.name.value, S);
        }
      });
    else if (e.externalFragments)
      throw new Error(
        "The `externalFragments` prop must either be a string that contains the fragment definitions in SDL or a list of FragmentDefinitionNode objects."
      );
    return v;
  }, [e.externalFragments]), E = G(
    () => e.validationRules || [],
    [e.validationRules]
  ), Z = G(
    () => ({
      ...m,
      addTab: $,
      changeTab: P,
      moveTab: O,
      closeTab: _,
      updateActiveTabValues: F,
      headerEditor: n,
      queryEditor: l,
      responseEditor: i,
      variableEditor: p,
      setHeaderEditor: r,
      setQueryEditor: a,
      setResponseEditor: u,
      setVariableEditor: h,
      setOperationName: M,
      initialQuery: g.query,
      initialVariables: g.variables,
      initialHeaders: g.headers,
      initialResponse: g.response,
      externalFragments: H,
      validationRules: E,
      shouldPersistHeaders: f,
      setShouldPersistHeaders: x
    }),
    [
      m,
      $,
      P,
      O,
      _,
      F,
      n,
      l,
      i,
      p,
      M,
      g,
      H,
      E,
      f,
      x
    ]
  );
  return /* @__PURE__ */ o(sn.Provider, { value: Z, children: W });
}
s(No, "EditorContextProvider");
const j = ce(sn), Ue = "shouldPersistHeaders", ko = `# Welcome to GraphiQL
#
# GraphiQL is an in-browser tool for writing, validating, and
# testing GraphQL queries.
#
# Type queries into this side of the screen, and you will see intelligent
# typeaheads aware of the current GraphQL type schema and live syntax and
# validation errors highlighted within the text.
#
# GraphQL queries typically start with a "{" character. Lines that start
# with a # are ignored.
#
# An example GraphQL query might look like:
#
#     {
#       field(arg: "value") {
#         subField
#       }
#     }
#
# Keyboard shortcuts:
#
#   Prettify query:  Shift-Ctrl-P (or press the prettify button)
#
#  Merge fragments:  Shift-Ctrl-M (or press the merge button)
#
#        Run Query:  Ctrl-Enter (or press the play button)
#
#    Auto Complete:  Ctrl-Space (or just start typing)
#

`;
function Et({ isHidden: e, ...t }) {
  const { headerEditor: n } = j({
    nonNull: !0,
    caller: Et
  }), r = Ce(t, Et);
  return R(() => {
    e || n == null || n.refresh();
  }, [n, e]), /* @__PURE__ */ o("div", { className: Q("graphiql-editor", e && "hidden"), ref: r });
}
s(Et, "HeaderEditor");
function lt(e) {
  var p;
  const [t, n] = I({
    width: null,
    height: null
  }), [r, l] = I(null), a = B(null), i = (p = an(e.token)) == null ? void 0 : p.href;
  R(() => {
    if (a.current) {
      if (!i) {
        n({ width: null, height: null }), l(null);
        return;
      }
      fetch(i, { method: "HEAD" }).then((h) => {
        l(h.headers.get("Content-Type"));
      }).catch(() => {
        l(null);
      });
    }
  }, [i]);
  const u = t.width !== null && t.height !== null ? /* @__PURE__ */ T("div", { children: [
    t.width,
    "x",
    t.height,
    r === null ? null : " " + r
  ] }) : null;
  return /* @__PURE__ */ T("div", { children: [
    /* @__PURE__ */ o(
      "img",
      {
        onLoad: () => {
          var h, f;
          n({
            width: ((h = a.current) == null ? void 0 : h.naturalWidth) ?? null,
            height: ((f = a.current) == null ? void 0 : f.naturalHeight) ?? null
          });
        },
        ref: a,
        src: i
      }
    ),
    u
  ] });
}
s(lt, "ImagePreview");
lt.shouldRender = /* @__PURE__ */ s(function(t) {
  const n = an(t);
  return n ? To(n) : !1;
}, "shouldRender");
function an(e) {
  if (e.type !== "string")
    return;
  const t = e.string.slice(1).slice(0, -1).trim();
  try {
    const { location: n } = window;
    return new URL(t, n.protocol + "//" + n.host);
  } catch {
    return;
  }
}
s(an, "tokenToURL");
function To(e) {
  return /(bmp|gif|jpeg|jpg|png|svg)$/.test(e.pathname);
}
s(To, "isImageURL");
function Mo(e) {
  const t = se(e, Mo);
  return /* @__PURE__ */ o("div", { className: "graphiql-editor", ref: t });
}
s(Mo, "QueryEditor");
function it({
  responseTooltip: e,
  editorTheme: t = _e,
  keyMap: n = $e
} = {}, r) {
  const { fetchError: l, validationErrors: a } = re({
    nonNull: !0,
    caller: r || it
  }), { initialResponse: i, responseEditor: u, setResponseEditor: p } = j({
    nonNull: !0,
    caller: r || it
  }), h = B(null), f = B(
    e
  );
  return R(() => {
    f.current = e;
  }, [e]), R(() => {
    let y = !0;
    return Ne(
      [
        import("./foldgutter.es.js").then((d) => d.f),
        import("./brace-fold.es.js").then((d) => d.b),
        import("./dialog.es.js").then((d) => d.d),
        import("./search.es.js").then((d) => d.s),
        import("./searchcursor.es.js").then((d) => d.s),
        import("./jump-to-line.es.js").then((d) => d.j),
        // @ts-expect-error
        import("./sublime.es.js").then((d) => d.s),
        import("./mode.es3.js"),
        import("./info-addon.es.js")
      ],
      { useCommonAddons: !1 }
    ).then((d) => {
      if (!y)
        return;
      const g = document.createElement("div");
      d.registerHelper(
        "info",
        "graphql-results",
        (x, k, L, b) => {
          const w = [], V = f.current;
          return V && w.push(
            /* @__PURE__ */ o(V, { pos: b, token: x })
          ), lt.shouldRender(x) && w.push(
            /* @__PURE__ */ o(lt, { token: x }, "image-preview")
          ), w.length ? (pt.render(w, g), g) : (pt.unmountComponentAtNode(g), null);
        }
      );
      const m = h.current;
      if (!m)
        return;
      const C = d(m, {
        value: i,
        lineWrapping: !0,
        readOnly: !0,
        theme: t,
        mode: "graphql-results",
        foldGutter: !0,
        gutters: ["CodeMirror-foldgutter"],
        // @ts-expect-error
        info: !0,
        extraKeys: Ze
      });
      p(C);
    }), () => {
      y = !1;
    };
  }, [t, i, p]), Ge(u, "keyMap", n), R(() => {
    l && (u == null || u.setValue(l)), a.length > 0 && (u == null || u.setValue(ve(a)));
  }, [u, l, a]), h;
}
s(it, "useResponseEditor");
function Vo(e) {
  const t = it(e, Vo);
  return /* @__PURE__ */ o(
    "section",
    {
      className: "result-window",
      "aria-label": "Result Window",
      "aria-live": "polite",
      "aria-atomic": "true",
      ref: t
    }
  );
}
s(Vo, "ResponseEditor");
function Lt({ isHidden: e, ...t }) {
  const { variableEditor: n } = j({
    nonNull: !0,
    caller: Lt
  }), r = me(t, Lt);
  return R(() => {
    n && !e && n.refresh();
  }, [n, e]), /* @__PURE__ */ o("div", { className: Q("graphiql-editor", e && "hidden"), ref: r });
}
s(Lt, "VariableEditor");
function ul({
  children: e,
  dangerouslyAssumeSchemaIsValid: t,
  defaultQuery: n,
  defaultHeaders: r,
  defaultTabs: l,
  externalFragments: a,
  fetcher: i,
  getDefaultFieldNames: u,
  headers: p,
  inputValueDeprecation: h,
  introspectionQueryName: f,
  maxHistoryLength: y,
  onEditOperationName: d,
  onSchemaChange: g,
  onTabChange: m,
  onTogglePluginVisibility: C,
  operationName: x,
  plugins: k,
  query: L,
  response: b,
  schema: w,
  schemaDescription: V,
  shouldPersistHeaders: W,
  storage: $,
  validationRules: P,
  variables: O,
  visiblePlugin: _
}) {
  return /* @__PURE__ */ o(On, { storage: $, children: /* @__PURE__ */ o(_r, { maxHistoryLength: y, children: /* @__PURE__ */ o(
    No,
    {
      defaultQuery: n,
      defaultHeaders: r,
      defaultTabs: l,
      externalFragments: a,
      headers: p,
      onEditOperationName: d,
      onTabChange: m,
      query: L,
      response: b,
      shouldPersistHeaders: W,
      validationRules: P,
      variables: O,
      children: /* @__PURE__ */ o(
        Gt,
        {
          dangerouslyAssumeSchemaIsValid: t,
          fetcher: i,
          inputValueDeprecation: h,
          introspectionQueryName: f,
          onSchemaChange: g,
          schema: w,
          schemaDescription: V,
          children: /* @__PURE__ */ o(
            et,
            {
              getDefaultFieldNames: u,
              fetcher: i,
              operationName: x,
              children: /* @__PURE__ */ o(jt, { children: /* @__PURE__ */ o(
                so,
                {
                  onTogglePluginVisibility: C,
                  plugins: k,
                  visiblePlugin: _,
                  children: e
                }
              ) })
            }
          )
        }
      )
    }
  ) }) });
}
s(ul, "GraphiQLProvider");
function dl() {
  const e = ue(), [t, n] = I(() => {
    if (!e)
      return null;
    const l = e.get(Ke);
    switch (l) {
      case "light":
        return "light";
      case "dark":
        return "dark";
      default:
        return typeof l == "string" && e.set(Ke, ""), null;
    }
  });
  Je(() => {
    typeof window > "u" || (document.body.classList.remove("graphiql-light", "graphiql-dark"), t && document.body.classList.add(`graphiql-${t}`));
  }, [t]);
  const r = N(
    (l) => {
      e == null || e.set(Ke, l || ""), n(l);
    },
    [e]
  );
  return G(() => ({ theme: t, setTheme: r }), [t, r]);
}
s(dl, "useTheme");
const Ke = "theme";
function hl({
  defaultSizeRelation: e = Ho,
  direction: t,
  initiallyHidden: n,
  onHiddenElementChange: r,
  sizeThresholdFirst: l = 100,
  sizeThresholdSecond: a = 100,
  storageKey: i
}) {
  const u = ue(), p = G(
    () => fe(500, (L) => {
      i && (u == null || u.set(i, L));
    }),
    [u, i]
  ), [h, f] = I(
    () => {
      const L = i && (u == null ? void 0 : u.get(i));
      return L === Ve || n === "first" ? "first" : L === He || n === "second" ? "second" : null;
    }
  ), y = N(
    (L) => {
      L !== h && (f(L), r == null || r(L));
    },
    [h, r]
  ), d = B(null), g = B(null), m = B(null), C = B(`${e}`);
  Je(() => {
    const L = i && (u == null ? void 0 : u.get(i)) || C.current;
    d.current && (d.current.style.display = "flex", d.current.style.flex = L === Ve || L === He ? C.current : L), m.current && (m.current.style.display = "flex", m.current.style.flex = "1"), g.current && (g.current.style.display = "flex");
  }, [t, u, i]);
  const x = N((L) => {
    const b = L === "first" ? d.current : m.current;
    if (b && (b.style.left = "-1000px", b.style.position = "absolute", b.style.opacity = "0", b.style.height = "500px", b.style.width = "500px", d.current)) {
      const w = parseFloat(d.current.style.flex);
      (!Number.isFinite(w) || w < 1) && (d.current.style.flex = "1");
    }
  }, []), k = N(
    (L) => {
      const b = L === "first" ? d.current : m.current;
      if (b && (b.style.width = "", b.style.height = "", b.style.opacity = "", b.style.position = "", b.style.left = "", u && i)) {
        const w = u.get(i);
        d.current && w !== Ve && w !== He && (d.current.style.flex = w || C.current);
      }
    },
    [u, i]
  );
  return Je(() => {
    h === "first" ? x("first") : k("first"), h === "second" ? x("second") : k("second");
  }, [h, x, k]), R(() => {
    if (!g.current || !d.current || !m.current)
      return;
    const L = g.current, b = d.current, w = b.parentElement, V = t === "horizontal" ? "clientX" : "clientY", W = t === "horizontal" ? "left" : "top", $ = t === "horizontal" ? "right" : "bottom", P = t === "horizontal" ? "clientWidth" : "clientHeight";
    function O(F) {
      F.preventDefault();
      const A = F[V] - L.getBoundingClientRect()[W];
      function M(E) {
        if (E.buttons === 0)
          return H();
        const Z = E[V] - w.getBoundingClientRect()[W] - A, v = w.getBoundingClientRect()[$] - E[V] + A - L[P];
        if (Z < l)
          y("first"), p(Ve);
        else if (v < a)
          y("second"), p(He);
        else {
          y(null);
          const S = `${Z / v}`;
          b.style.flex = S, p(S);
        }
      }
      s(M, "handleMouseMove");
      function H() {
        document.removeEventListener("mousemove", M), document.removeEventListener("mouseup", H);
      }
      s(H, "handleMouseUp"), document.addEventListener("mousemove", M), document.addEventListener("mouseup", H);
    }
    s(O, "handleMouseDown"), L.addEventListener("mousedown", O);
    function _() {
      d.current && (d.current.style.flex = C.current), p(C.current), y(null);
    }
    return s(_, "reset"), L.addEventListener("dblclick", _), () => {
      L.removeEventListener("mousedown", O), L.removeEventListener("dblclick", _);
    };
  }, [
    t,
    y,
    l,
    a,
    p
  ]), G(
    () => ({
      dragBarRef: g,
      hiddenElement: h,
      firstRef: d,
      setHiddenElement: f,
      secondRef: m
    }),
    [h, f]
  );
}
s(hl, "useDragResize");
const Ho = 1, Ve = "hide-first", He = "hide-second";
const Ao = K(({ label: e, onClick: t, ...n }, r) => {
  const [l, a] = I(null), i = N(
    (u) => {
      try {
        t == null || t(u), a(null);
      } catch (p) {
        a(
          p instanceof Error ? p : new Error(`Toolbar button click failed: ${p}`)
        );
      }
    },
    [t]
  );
  return /* @__PURE__ */ o(ne, { label: e, children: /* @__PURE__ */ o(
    J,
    {
      ...n,
      ref: r,
      type: "button",
      className: Q(
        "graphiql-toolbar-button",
        l && "error",
        n.className
      ),
      onClick: i,
      "aria-label": l ? l.message : e,
      "aria-invalid": l ? "true" : n["aria-invalid"]
    }
  ) });
});
Ao.displayName = "ToolbarButton";
function St() {
  const { queryEditor: e, setOperationName: t } = j({
    nonNull: !0,
    caller: St
  }), { isFetching: n, isSubscribed: r, operationName: l, run: a, stop: i } = We({
    nonNull: !0,
    caller: St
  }), u = (e == null ? void 0 : e.operations) || [], p = u.length > 1 && typeof l != "string", h = n || r, f = `${h ? "Stop" : "Execute"} query (Ctrl-Enter)`, y = {
    type: "button",
    className: "graphiql-execute-button",
    children: h ? /* @__PURE__ */ o(Rr, {}) : /* @__PURE__ */ o(Vr, {}),
    "aria-label": f
  };
  return p && !h ? /* @__PURE__ */ T(le, { children: [
    /* @__PURE__ */ o(ne, { label: f, children: /* @__PURE__ */ o(le.Button, { ...y }) }),
    /* @__PURE__ */ o(le.Content, { children: u.map((d, g) => {
      const m = d.name ? d.name.value : `<Unnamed ${d.operation}>`;
      return /* @__PURE__ */ o(
        le.Item,
        {
          onSelect: () => {
            var x;
            const C = (x = d.name) == null ? void 0 : x.value;
            e && C && C !== e.operationName && t(C), a();
          },
          children: m
        },
        `${m}-${g}`
      );
    }) })
  ] }) : /* @__PURE__ */ o(ne, { label: f, children: /* @__PURE__ */ o(
    "button",
    {
      ...y,
      onClick: () => {
        h ? i() : a();
      }
    }
  ) });
}
s(St, "ExecuteButton");
const qo = /* @__PURE__ */ s(({
  button: e,
  children: t,
  label: n,
  ...r
}) => /* @__PURE__ */ T(le, { ...r, children: [
  /* @__PURE__ */ o(ne, { label: n, children: /* @__PURE__ */ o(
    le.Button,
    {
      className: Q(
        "graphiql-un-styled graphiql-toolbar-menu",
        r.className
      ),
      "aria-label": n,
      children: e
    }
  ) }),
  /* @__PURE__ */ o(le.Content, { children: t })
] }), "ToolbarMenuRoot"), ml = Se(qo, {
  Item: le.Item
});
export {
  Pe as Argument,
  gr as ArgumentIcon,
  Le as Button,
  Pr as ButtonGroup,
  Uo as ChevronDownIcon,
  Cr as ChevronLeftIcon,
  Ko as ChevronUpIcon,
  st as CloseIcon,
  Jo as CopyIcon,
  ye as DOC_EXPLORER_PLUGIN,
  $t as DefaultValue,
  vr as DeprecatedArgumentIcon,
  yr as DeprecatedEnumValueIcon,
  br as DeprecatedFieldIcon,
  zt as DeprecationReason,
  ol as Dialog,
  Ir as DialogRoot,
  Ur as Directive,
  wr as DirectiveIcon,
  rt as DocExplorer,
  xr as DocsFilledIcon,
  Er as DocsIcon,
  le as DropdownMenu,
  sn as EditorContext,
  No as EditorContextProvider,
  Lr as EnumValueIcon,
  St as ExecuteButton,
  Bt as ExecutionContext,
  et as ExecutionContextProvider,
  Qt as ExplorerContext,
  jt as ExplorerContextProvider,
  U as ExplorerSection,
  Jr as FieldDocumentation,
  Sr as FieldIcon,
  to as FieldLink,
  ul as GraphiQLProvider,
  bt as HISTORY_PLUGIN,
  Et as HeaderEditor,
  Zr as History,
  Ft as HistoryContext,
  _r as HistoryContextProvider,
  Nr as HistoryIcon,
  lt as ImagePreview,
  kr as ImplementsIcon,
  Yo as KeyboardShortcutIcon,
  Tr as MagnifyingGlassIcon,
  te as MarkdownContent,
  Xo as MergeIcon,
  Mr as PenIcon,
  Vr as PlayIcon,
  Kt as PluginContext,
  so as PluginContextProvider,
  el as PlusIcon,
  tl as PrettifyIcon,
  Mo as QueryEditor,
  nl as ReloadIcon,
  Vo as ResponseEditor,
  Hr as RootTypeIcon,
  Zt as SchemaContext,
  Gt as SchemaContextProvider,
  eo as SchemaDocumentation,
  Ut as Search,
  rl as SettingsIcon,
  Dt as Spinner,
  Ar as StarFilledIcon,
  qr as StarIcon,
  Rr as StopIcon,
  At as StorageContext,
  On as StorageContextProvider,
  ll as Tab,
  Wr as Tabs,
  Ao as ToolbarButton,
  ml as ToolbarMenu,
  ne as Tooltip,
  Br as TooltipRoot,
  Dr as TrashIcon,
  no as TypeDocumentation,
  ke as TypeIcon,
  X as TypeLink,
  J as UnStyledButton,
  Lt as VariableEditor,
  ot as useAutoCompleteLeafs,
  Xt as useCopyQuery,
  hl as useDragResize,
  j as useEditorContext,
  ct as useEditorState,
  We as useExecutionContext,
  ie as useExplorerContext,
  Ce as useHeaderEditor,
  al as useHeadersEditorState,
  Be as useHistoryContext,
  be as useMergeQuery,
  il as useOperationsEditorState,
  cl as useOptimisticState,
  at as usePluginContext,
  Qe as usePrettifyEditors,
  se as useQueryEditor,
  it as useResponseEditor,
  re as useSchemaContext,
  ue as useStorageContext,
  dl as useTheme,
  me as useVariableEditor,
  sl as useVariablesEditorState
};
//# sourceMappingURL=index.mjs.map
